import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js/instance/slice';
import _Array$from from '@babel/runtime-corejs3/core-js/array/from';
import _Symbol from '@babel/runtime-corejs3/core-js/symbol';
import _getIteratorMethod from '@babel/runtime-corejs3/core-js/get-iterator-method';
import _asyncToGenerator from '@babel/runtime-corejs3/helpers/asyncToGenerator';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _values from 'lodash/values';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js/instance/index-of';
import _spliceInstanceProperty from '@babel/runtime-corejs3/core-js/instance/splice';
import _regeneratorRuntime from '@babel/runtime-corejs3/regenerator';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _includes from 'lodash/includes';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js/object/define-property';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _startsWith from 'lodash/startsWith';
import _set from 'lodash/set';
import _pickBy from 'lodash/pickBy';
import _omit from 'lodash/omit';
import _get from 'lodash/get';
import _each from 'lodash/each';
import axios from 'axios';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js/instance/includes';
import _Promise from '@babel/runtime-corejs3/core-js/promise';
import _setImmediate from '@babel/runtime-corejs3/core-js/set-immediate';
import _isFunction from 'lodash/isFunction';
import _uniq from 'lodash/uniq';
import _parseInt from '@babel/runtime-corejs3/core-js/parse-int';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import _pick from 'lodash/pick';
import _keys from 'lodash/keys';
import _isArray from 'lodash/isArray';
import _cloneDeep from 'lodash/cloneDeep';
import _URL from '@babel/runtime-corejs3/core-js/url';
import _JSON$stringify from '@babel/runtime-corejs3/core-js/json/stringify';
import pRetry from 'p-retry';
import _map from 'lodash/map';
import _reduce from 'lodash/reduce';
import _isString from 'lodash/isString';
import _isPlainObject from 'lodash/isPlainObject';
import _find from 'lodash/find';
import qs from 'qs';
import _Reflect$construct from '@babel/runtime-corejs3/core-js/reflect/construct';
import _assertThisInitialized from '@babel/runtime-corejs3/helpers/assertThisInitialized';
import _get$1 from '@babel/runtime-corejs3/helpers/get';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import _isObject from 'lodash/isObject';
import _merge from 'lodash/merge';
import _isBoolean from 'lodash/isBoolean';
import _filter from 'lodash/filter';
import _parseFloat from '@babel/runtime-corejs3/core-js/parse-float';

(function () {
  if (window['rnw.locationchangeEventAdded']) {
    return;
  }

  window.history.pushState = function (f) {
    return function () {
      // eslint-disable-next-line prefer-rest-params
      var ret = f.apply(this, arguments);
      window.dispatchEvent(new CustomEvent('rnw.pushstate'));
      window.dispatchEvent(new CustomEvent('rnw.locationchange'));
      return ret;
    };
  }(window.history.pushState);

  window.history.replaceState = function (f) {
    return function () {
      // eslint-disable-next-line prefer-rest-params
      var ret = f.apply(this, arguments);
      window.dispatchEvent(new CustomEvent('rnw.replacestate'));
      window.dispatchEvent(new CustomEvent('rnw.locationchange'));
      return ret;
    };
  }(window.history.replaceState);

  window.addEventListener('popstate', function () {
    window.dispatchEvent(new CustomEvent('rnw.locationchange'));
  });
  window['rnw.locationchangeEventAdded'] = true;
})(); // https://stackoverflow.com/questions/56577201/why-is-isolatedmodules-error-fixed-by-any-import

var CreditCardIframeMessageType;

(function (CreditCardIframeMessageType) {
  CreditCardIframeMessageType["EPIK_CONFIG"] = "rnw.credit-card.sync-epik-config";
  CreditCardIframeMessageType["HEIGHT"] = "rnw.credit-card.height";
  CreditCardIframeMessageType["SET_LANGUAGE"] = "rnw.credit-card.set-language";
  CreditCardIframeMessageType["SET_FLOW"] = "rnw.credit-card.set-flow";
  CreditCardIframeMessageType["VALIDATE"] = "rnw.credit-card.validate";
  CreditCardIframeMessageType["VALIDATE_SUCCESS"] = "rnw.credit-card.validate:success";
  CreditCardIframeMessageType["VALIDATE_ERROR"] = "rnw.credit-card.validate:error";
  CreditCardIframeMessageType["TOKENIZE"] = "rnw.credit-card.tokenize";
  CreditCardIframeMessageType["TOKENIZE_SUCCESS"] = "rnw.credit-card.tokenize:success";
  CreditCardIframeMessageType["TOKENIZE_ERROR"] = "rnw.credit-card.tokenize:error";
  CreditCardIframeMessageType["DETECT_CREDIT_CARD_TYPE"] = "rnw.credit-card.detect-credit-card-type";
  CreditCardIframeMessageType["DATA_CHANGED"] = "rnw.credit-card.data:changed";
  CreditCardIframeMessageType["CREDIT_CARD_TYPE_CHANGED"] = "rnw.credit-card.credit-card-type:changed";
  CreditCardIframeMessageType["MARK_ALL_FIELDS_AS_TOUCHED"] = "rnw.credit-card.mark-all-fields-as-touched";
  CreditCardIframeMessageType["SUBMIT"] = "rnw.credit-card.submit";
})(CreditCardIframeMessageType || (CreditCardIframeMessageType = {}));

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { var _context4; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = _sliceInstanceProperty(_context4 = Object.prototype.toString.call(o)).call(_context4, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

///////////////////////////////////////////////////////////////////////////////
var EpikEventName;

(function (EpikEventName) {
  EpikEventName["FETCH_PAYMENT_DATA_START"] = "fetchPaymentDataStart";
  EpikEventName["FETCH_PAYMENT_DATA_END"] = "fetchPaymentDataEnd";
  EpikEventName["EPP_PAYMENT_STATUS_POLL"] = "eppPaymentStatusPoll";
  EpikEventName["EPMS_PAYMENT_STATUS_POLL"] = "epmsPaymentStatusPoll";
  EpikEventName["SEND_EPP_PAYMENT_START"] = "sendEppPaymentStart";
  EpikEventName["SEND_EPMS_PAYMENT_START"] = "sendEpmsPaymentStart";
  EpikEventName["SEND_EPMS_PAYMENT_END"] = "sendEpmsPaymentEnd";
  EpikEventName["SEND_EPMS_PAYMENT_ERROR"] = "sendEpmsPaymentError";
  EpikEventName["UPDATE_EPMS_SUBSCRIPTION_START"] = "updateEpmsSubscriptionStart";
  EpikEventName["UPDATE_EPMS_SUBSCRIPTION_END"] = "updateEpmsSubscriptionEnd";
  EpikEventName["UPDATE_EPMS_SUBSCRIPTION_ERROR"] = "updateEpmsSubscriptionError";
})(EpikEventName || (EpikEventName = {}));

///////////////////////////////////////////////////////////////////////////////
var EpikEventer = /*#__PURE__*/function () {
  function EpikEventer(eventName) {
    _classCallCheck(this, EpikEventer);

    _defineProperty(this, "handlers", []);

    this.eventName = eventName;
  }

  _createClass(EpikEventer, [{
    key: "publish",
    value: function () {
      var _publish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
        var event, _iterator, _step, handler;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event = {
                  eventName: this.eventName
                };

                if (data) {
                  event.data = data;
                }

                _iterator = _createForOfIteratorHelper$1(this.handlers);
                _context.prev = 3;

                _iterator.s();

              case 5:
                if ((_step = _iterator.n()).done) {
                  _context.next = 11;
                  break;
                }

                handler = _step.value;
                _context.next = 9;
                return handler(event);

              case 9:
                _context.next = 5;
                break;

              case 11:
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](3);

                _iterator.e(_context.t0);

              case 16:
                _context.prev = 16;

                _iterator.f();

                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 13, 16, 19]]);
      }));

      function publish(_x) {
        return _publish.apply(this, arguments);
      }

      return publish;
    }()
  }, {
    key: "subscribe",
    value: function subscribe(handler) {
      var _this = this;

      this.handlers.push(handler);
      return function () {
        var _context2;

        var idx = _indexOfInstanceProperty(_context2 = _this.handlers).call(_context2, handler);

        if (idx !== -1) {
          var _context3;

          _spliceInstanceProperty(_context3 = _this.handlers).call(_context3, idx, 1);
        }
      };
    }
  }]);

  return EpikEventer;
}(); ///////////////////////////////////////////////////////////////////////////////

var createEpikEvents = function createEpikEvents() {
  var result = {};

  var _iterator2 = _createForOfIteratorHelper$1(_values(EpikEventName)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var eventName = _step2.value;
      result[eventName] = new EpikEventer(eventName);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return result;
};

var EpikQueryParam; ///////////////////////////////////////////////////////////////////////////////

(function (EpikQueryParam) {
  EpikQueryParam["EPP_TRANSACTION_ID"] = "epp_transaction_id";
  EpikQueryParam["SUBSCRIPTION_TOKEN"] = "subscription_token";
  EpikQueryParam["LEMA_SUBSCRIPTION_TOKEN"] = "dds-subscription";
  EpikQueryParam["CUSTOMER_TOKEN"] = "customer_token";
  EpikQueryParam["VIEW"] = "rnw-view";
  EpikQueryParam["EPMS_PAYMENT_UUID"] = "epms_payment_uuid";
  EpikQueryParam["EPMS_SUBSCRIPTION_UUID"] = "epms_subscription_uuid";
})(EpikQueryParam || (EpikQueryParam = {}));

var AllEpikQueryParams = [EpikQueryParam.EPP_TRANSACTION_ID, EpikQueryParam.SUBSCRIPTION_TOKEN, EpikQueryParam.LEMA_SUBSCRIPTION_TOKEN, EpikQueryParam.CUSTOMER_TOKEN, EpikQueryParam.VIEW, EpikQueryParam.EPMS_PAYMENT_UUID, EpikQueryParam.EPMS_SUBSCRIPTION_UUID];
var WatchedEpikQueryParams = [EpikQueryParam.EPP_TRANSACTION_ID, EpikQueryParam.SUBSCRIPTION_TOKEN, EpikQueryParam.LEMA_SUBSCRIPTION_TOKEN, EpikQueryParam.CUSTOMER_TOKEN, EpikQueryParam.EPMS_PAYMENT_UUID, EpikQueryParam.EPMS_SUBSCRIPTION_UUID];

var EpmsPaymentStatus;

(function (EpmsPaymentStatus) {
  EpmsPaymentStatus["PENDING"] = "pending";
  EpmsPaymentStatus["SUCCEEDED"] = "succeeded";
  EpmsPaymentStatus["FAILED"] = "failed";
  EpmsPaymentStatus["REFUNDED"] = "refunded";
  EpmsPaymentStatus["PARTIALLY_REFUNDED"] = "partially_refunded";
})(EpmsPaymentStatus || (EpmsPaymentStatus = {}));

var EpmsPaymentStatusReason;

(function (EpmsPaymentStatusReason) {
  EpmsPaymentStatusReason["NEW"] = "new";
  EpmsPaymentStatusReason["PENDING"] = "pending";
  EpmsPaymentStatusReason["UNKNOWN"] = "unknown";
  EpmsPaymentStatusReason["SUCCEEDED"] = "succeeded";
  EpmsPaymentStatusReason["ERROR"] = "error";
  EpmsPaymentStatusReason["USER_TIMEOUT"] = "user_timeout";
  EpmsPaymentStatusReason["USER_ABORTED"] = "user_aborted";
  EpmsPaymentStatusReason["DECLINED"] = "declined";
  EpmsPaymentStatusReason["REFUNDED"] = "refunded";
  EpmsPaymentStatusReason["PARTIALLY_REFUNDED"] = "partially_refunded";
})(EpmsPaymentStatusReason || (EpmsPaymentStatusReason = {}));

///////////////////////////////////////////////////////////////////////////////
var EpmsSubscriptionStatus;

(function (EpmsSubscriptionStatus) {
  EpmsSubscriptionStatus["ACTIVE"] = "active";
  EpmsSubscriptionStatus["CANCELLED"] = "cancelled";
})(EpmsSubscriptionStatus || (EpmsSubscriptionStatus = {}));

var PaymentCurrency;

(function (PaymentCurrency) {
  PaymentCurrency["CHF"] = "chf";
  PaymentCurrency["EUR"] = "eur";
  PaymentCurrency["USD"] = "usd";
})(PaymentCurrency || (PaymentCurrency = {}));

///////////////////////////////////////////////////////////////////////////////
var PaymentMethod; ///////////////////////////////////////////////////////////////////////////////

(function (PaymentMethod) {
  PaymentMethod["CREDIT_CARD"] = "cc";
  PaymentMethod["AMERICAN_EXPRESS"] = "amx";
  PaymentMethod["CYMBA"] = "cym";
  PaymentMethod["DINERS_CLUB"] = "din";
  PaymentMethod["DIRECT_DEBIT"] = "dd";
  PaymentMethod["DISCOVERY"] = "dis";
  PaymentMethod["WEBBANKING_INDIA"] = "ebs";
  PaymentMethod["ELEKTRONISCHES_LASTSCHRIFTVERFAHREN"] = "elv";
  PaymentMethod["ELECTRONIC_PAYMENT_SERVICE"] = "eps";
  PaymentMethod["JAPANESE_CREDIT_BUREAU"] = "jcb";
  PaymentMethod["MAESTRO"] = "mae";
  PaymentMethod["MASTER_CARD"] = "eca";
  PaymentMethod["MASTER_PASS"] = "mpw";
  PaymentMethod["PAYMENT_SLIP"] = "es";
  PaymentMethod["PAYMENT_SLIP_WITH_REFERENCE_NUMBER"] = "ezs";
  PaymentMethod["SWISS_QR_BILL"] = "chqr";
  PaymentMethod["PAY_PAL"] = "pp";
  PaymentMethod["POST_FINANCE"] = "pef";
  PaymentMethod["POST_FINANCE_CARD"] = "pfc";
  PaymentMethod["SEPA_ONE"] = "sod";
  PaymentMethod["SMS"] = "sms";
  PaymentMethod["SOFORT"] = "dib";
  PaymentMethod["STRIPE"] = "stp";
  PaymentMethod["TWINT"] = "twi";
  PaymentMethod["VISA"] = "vis";
  PaymentMethod["MPOS"] = "mpos";
})(PaymentMethod || (PaymentMethod = {}));

var CreditCardPaymentMethods = [PaymentMethod.CREDIT_CARD, PaymentMethod.AMERICAN_EXPRESS, PaymentMethod.DINERS_CLUB, PaymentMethod.DISCOVERY, PaymentMethod.JAPANESE_CREDIT_BUREAU, PaymentMethod.MAESTRO, PaymentMethod.MASTER_CARD, PaymentMethod.VISA, PaymentMethod.STRIPE];
var PostFinancePaymentMethods = [PaymentMethod.POST_FINANCE, PaymentMethod.POST_FINANCE_CARD];
var PaymentMethodsWithDeferredStatus = [PaymentMethod.SMS, PaymentMethod.MPOS];
var FallbackCreditCardPaymentMethod = PaymentMethod.VISA;
var isSupportedPaymentMethod = function isSupportedPaymentMethod(paymentMethod) {
  var _context;

  return _includesInstanceProperty(_context = _values(PaymentMethod)).call(_context, paymentMethod);
};
var isCreditCardPaymentMethod = function isCreditCardPaymentMethod(paymentMethod) {
  return _includesInstanceProperty(CreditCardPaymentMethods).call(CreditCardPaymentMethods, paymentMethod) || paymentMethod === 'card';
};
var isPostFinancePaymentMethod = function isPostFinancePaymentMethod(paymentMethod) {
  return _includesInstanceProperty(PostFinancePaymentMethods).call(PostFinancePaymentMethods, paymentMethod);
};
var isPaymentMethodWithDeferredStatus = function isPaymentMethodWithDeferredStatus(paymentMethod) {
  return _includesInstanceProperty(PaymentMethodsWithDeferredStatus).call(PaymentMethodsWithDeferredStatus, paymentMethod);
};
var getCreditCardType = function getCreditCardType(cardNumber) {
  if (!cardNumber) {
    return null;
  }

  cardNumber = cardNumber.replace(/[A-z\s-]+/g, '');

  if (cardNumber.match(/^(4)/g)) {
    return PaymentMethod.VISA;
  }

  if (cardNumber.match(/^(5[0-5])/g)) {
    return PaymentMethod.MASTER_CARD;
  }

  if (cardNumber.match(/^3[4|7]/g)) {
    return PaymentMethod.AMERICAN_EXPRESS;
  }

  if (cardNumber.match(/^36/g)) {
    return PaymentMethod.DINERS_CLUB;
  }

  if (cardNumber.match(/^6((011)|5)/g)) {
    return PaymentMethod.DISCOVERY;
  }

  if (cardNumber.match(/^(5[06789]|6)[0-9]{0,}$/g)) {
    return PaymentMethod.MAESTRO;
  }

  if (cardNumber.match(/^35/g)) {
    return PaymentMethod.JAPANESE_CREDIT_BUREAU;
  }

  return null;
};

///////////////////////////////////////////////////////////////////////////////
var PaymentProvider; ///////////////////////////////////////////////////////////////////////////////

(function (PaymentProvider) {
  PaymentProvider["ADYEN"] = "adyen";
  PaymentProvider["DATATRANS"] = "datatrans";
  PaymentProvider["INGCOLLECT"] = "ingcollect";
  PaymentProvider["STRIPE"] = "stripe";
})(PaymentProvider || (PaymentProvider = {}));

var isSupportedPaymentProvider = function isSupportedPaymentProvider(paymentProvider) {
  var _context;

  return _includesInstanceProperty(_context = _values(PaymentProvider)).call(_context, paymentProvider);
};

function ownKeys$3(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

///////////////////////////////////////////////////////////////////////////////
var SUPPORTER_FIELDS = {
  uuid: 'stored_customer_uuid',
  salutation: 'stored_customer_salutation',
  first_name: 'stored_customer_firstname',
  last_name: 'stored_customer_lastname',
  raw_name: 'stored_customer_raw_name',
  email: 'stored_customer_email',
  email_permission: 'stored_customer_email_permission',
  street: 'stored_customer_street',
  house_number: 'stored_customer_street_number',
  address_addendum: 'stored_customer_street2',
  postal_code: 'stored_customer_zip_code',
  city: 'stored_customer_city',
  country: 'stored_customer_country',
  region_level_1: 'stored_customer_state',
  raw_address: 'stored_customer_raw_address'
};
var SUPPORTER_METADATA_FIELDS = {
  post_office_box: 'stored_customer_pobox'
};
var RNW_INTEGRATION_FIELDS = {
  donation_receipt_requested: 'stored_customer_donation_receipt',
  message: 'stored_customer_message'
};
var RNW_PRODUCT_FIELDS = {
  name: 'stored_rnw_product_name',
  version: 'stored_rnw_product_version',
  uuid: 'stored_rnw_widget_uuid',
  source_url: 'stored_rnw_source_url'
};
var RNW_COVER_FEE_FIELDS = {
  fixed: 'stored_rnw_cover_fee_fixed',
  percentage: 'stored_rnw_cover_fee_percentage',
  amount: 'stored_rnw_cover_fee_amount'
};
var RNW_ANALYTICS_FIELDS = {
  suggested_amounts: 'stored_rnw_analytics_suggested_amounts',
  preselected_amount: 'stored_rnw_analytics_preselected_amount',
  user_agent: 'stored_rnw_analytics_user_agent'
};
var IGNORED_FIELDS = ['stored_customer_birthdate']; ///////////////////////////////////////////////////////////////////////////////

var PaymentFlowEpms = /*#__PURE__*/function () {
  function PaymentFlowEpms() {
    _classCallCheck(this, PaymentFlowEpms);
  }

  _createClass(PaymentFlowEpms, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(epik, payment) {
        var epmsPaymentRequestData, _epmsPaymentRequestDa, epmsPaymentSourceRequestData, epmsSubscriptionUpdateRequestData, epmsPaymentSourceResponseData, payment_source_uuid, _error$response, epmsPaymentResponseData, _error$response2, _error$response3, epmsPaymentResponseError;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return preparePaymentData(payment, epik);

              case 2:
                epmsPaymentRequestData = _context.sent;

                if (!payment.epms_subscription_uuid) {
                  _context.next = 31;
                  break;
                }

                // update subscription
                epik.config.debug && console.debug('[epik] update subscription');
                _context.prev = 5;
                _context.next = 8;
                return epik.events[EpikEventName.UPDATE_EPMS_SUBSCRIPTION_START].publish();

              case 8:
                epmsPaymentSourceRequestData = _omit(epmsPaymentRequestData, 'subscription'); // todo: skip it when it will be supported on backend side

                epmsSubscriptionUpdateRequestData = {
                  currency_identifier: epmsPaymentRequestData.amount.currency,
                  amount: epmsPaymentRequestData.amount.value,
                  timezone: epmsPaymentRequestData.subscription.timezone,
                  recurring_interval: (_epmsPaymentRequestDa = epmsPaymentRequestData.custom_parameters) === null || _epmsPaymentRequestDa === void 0 ? void 0 : _epmsPaymentRequestDa.rnw_recurring_interval_name
                };
                _context.next = 12;
                return createPaymentSource(epmsPaymentSourceRequestData, epik);

              case 12:
                epmsPaymentSourceResponseData = _context.sent;
                payment_source_uuid = _get(epmsPaymentSourceResponseData, 'objects.payment_source_uuid');
                _context.next = 16;
                return epik.epmsProxy.updateSubscription({
                  epmsSubscriptionUuid: payment.epms_subscription_uuid,
                  update: _objectSpread$3(_objectSpread$3({}, epmsSubscriptionUpdateRequestData), {}, {
                    payment_source_uuid: payment_source_uuid
                  })
                });

              case 16:
                _context.next = 18;
                return epik.events[EpikEventName.UPDATE_EPMS_SUBSCRIPTION_END].publish({
                  epmsSubscriptionUuid: payment.epms_subscription_uuid
                });

              case 18:
                _context.next = 29;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](5);
                epik.config.debug && console.debug('[epik] update subscription error');

                if (!((_error$response = _context.t0.response) !== null && _error$response !== void 0 && _error$response.data)) {
                  _context.next = 28;
                  break;
                }

                _context.next = 26;
                return epik.events[EpikEventName.UPDATE_EPMS_SUBSCRIPTION_ERROR].publish({
                  epmsSubscriptionUuid: payment.epms_subscription_uuid,
                  error: _context.t0.response.data
                });

              case 26:
                _context.next = 29;
                break;

              case 28:
                throw _context.t0;

              case 29:
                _context.next = 52;
                break;

              case 31:
                // send payment
                epik.config.debug && console.debug('[epik] send payment');
                _context.prev = 32;
                _context.next = 35;
                return epik.events[EpikEventName.SEND_EPMS_PAYMENT_START].publish({
                  epmsPaymentRequestData: epmsPaymentRequestData
                });

              case 35:
                _context.next = 37;
                return sendPayment(epmsPaymentRequestData, epik);

              case 37:
                epmsPaymentResponseData = _context.sent;
                _context.next = 40;
                return epik.events[EpikEventName.SEND_EPMS_PAYMENT_END].publish({
                  epmsPaymentResponseData: epmsPaymentResponseData
                });

              case 40:
                _context.next = 52;
                break;

              case 42:
                _context.prev = 42;
                _context.t1 = _context["catch"](32);
                epik.config.debug && console.debug('[epik] send payment error');

                if (!((_error$response2 = _context.t1.response) !== null && _error$response2 !== void 0 && _error$response2.data)) {
                  _context.next = 51;
                  break;
                }

                epmsPaymentResponseError = (_error$response3 = _context.t1.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data;
                _context.next = 49;
                return epik.events[EpikEventName.SEND_EPMS_PAYMENT_ERROR].publish({
                  epmsPaymentResponseError: epmsPaymentResponseError
                });

              case 49:
                _context.next = 52;
                break;

              case 51:
                throw _context.t1;

              case 52:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 20], [32, 42]]);
      }));

      function start(_x, _x2) {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }]);

  return PaymentFlowEpms;
}(); ///////////////////////////////////////////////////////////////////////////////

var sendPayment = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(requestData, epik) {
    var _yield$axios$request, data;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return axios.request({
              url: epik.config.epmsApiUrl + '/pay',
              method: 'post',
              data: requestData
            });

          case 2:
            _yield$axios$request = _context2.sent;
            data = _yield$axios$request.data;
            return _context2.abrupt("return", data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function sendPayment(_x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var createPaymentSource = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(requestData, epik) {
    var _yield$axios$request2, data;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return axios.request({
              url: epik.config.epmsApiUrl + '/payment-sources',
              method: 'post',
              data: requestData
            });

          case 2:
            _yield$axios$request2 = _context3.sent;
            data = _yield$axios$request2.data;
            return _context3.abrupt("return", data);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function createPaymentSource(_x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

var preparePaymentData = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payment, epik) {
    var data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            data = {};
            prepareMainInfo(data, payment, epik);
            prepareSupporter(data, payment);
            prepareRnwIntegration(data, payment);
            prepareRnwProduct(data, payment);
            prepareRnwCoverFee(data, payment);
            prepareRnwAnalytics(data, payment);
            prepareCustomParameters(data, payment);
            prepareRecurringInfo(data, payment);
            preparePaymentInfo(data, payment);
            return _context4.abrupt("return", data);

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function preparePaymentData(_x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}(); ///////////////////////////////////////////////////////////////////////////////


var prepareMainInfo = function prepareMainInfo(data, payment, epik) {
  if (payment.profile) {
    data.profile = payment.profile;
  }

  data.account_uuid = epik.config.epmsAccountUuid;
  data.test_mode = payment.test_mode;
  data.return_url = payment.return_url;
  data.locale = payment.language;
  data.create_supporter = !!payment.create_supporter;
  data.supporter = payment.supporter || {};
  data.raisenow = payment.raisenow || {};
  data.custom_parameters = payment.custom_parameters || {};
  data.payment_information = payment.payment_information || {};
  data.create_payment_source = !!payment.create_payment_source;
  data.amount = {
    value: payment.amount,
    currency: payment.currency.toUpperCase()
  };
};

var prepareSupporter = function prepareSupporter(data, payment) {
  var _context5;

  _each(SUPPORTER_FIELDS, function (v, k) {
    var existingValue = _get(data, "supporter.".concat(k)); // don't override if field is already set


    if (payment[v] !== undefined && existingValue === undefined) {
      _set(data, "supporter.".concat(k), payment[v]);
    }
  });

  _each(SUPPORTER_METADATA_FIELDS, function (v, k) {
    var existingValue = _get(data, "supporter.metadata.".concat(k)); // don't override if field is already set


    if (payment[v] !== undefined && existingValue === undefined) {
      _set(data, "supporter.metadata.".concat(k), payment[v]);
    }
  }); // Add fields with "stored_customer_" prefix
  // (except specified ones)
  // to "customer.metadata"


  var info = _pickBy(payment, function (v, k) {
    return _startsWith(k, 'stored_customer_');
  });

  info = _omit(info, _concatInstanceProperty(_context5 = []).call(_context5, _toConsumableArray(_values(SUPPORTER_FIELDS)), _toConsumableArray(_values(SUPPORTER_METADATA_FIELDS)), _toConsumableArray(_values(RNW_INTEGRATION_FIELDS)), _toConsumableArray(_values(RNW_PRODUCT_FIELDS)), IGNORED_FIELDS));

  _each(info, function (v, k) {
    var key = k.replace(/^stored_customer_/, '');

    var existingValue = _get(data, "supporter.metadata.".concat(key)); // don't override if field is already set


    if (v !== undefined && existingValue === undefined) {
      _set(data, "supporter.metadata.".concat(key), v);
    }
  }); // Split stored_customer_birthdate


  if (payment.stored_customer_birthdate) {
    var _payment$stored_custo = payment.stored_customer_birthdate.split('-'),
        _payment$stored_custo2 = _slicedToArray(_payment$stored_custo, 3),
        birth_year = _payment$stored_custo2[0],
        birth_month = _payment$stored_custo2[1],
        birth_day = _payment$stored_custo2[2];

    if (birth_year) {
      _set(data, "supporter.metadata.birth_year", birth_year);
    }

    if (birth_month) {
      _set(data, "supporter.metadata.birth_month", birth_month);
    }

    if (birth_day) {
      _set(data, "supporter.metadata.birth_day", birth_day);
    }
  }
};

var prepareRnwIntegration = function prepareRnwIntegration(data, payment) {
  _each(RNW_INTEGRATION_FIELDS, function (v, k) {
    var existingValue = _get(payment, "raisenow.integration.".concat(k)); // don't override if field is already set


    if (payment[v] !== undefined && existingValue === undefined) {
      // value is casted to string
      // todo: refactor with payment team to not cast values
      _set(data, "raisenow.integration.".concat(k), '' + payment[v]);
    }
  });
};

var prepareRnwProduct = function prepareRnwProduct(data, payment) {
  _each(RNW_PRODUCT_FIELDS, function (v, k) {
    var existingValue = _get(payment, "raisenow.product.".concat(k)); // don't override if field is already set


    if (payment[v] !== undefined && existingValue === undefined) {
      // todo: refactor with payment team to not cast values
      _set(data, "raisenow.product.".concat(k), '' + payment[v]);
    }
  });
};

var prepareRnwCoverFee = function prepareRnwCoverFee(data, payment) {
  _each(RNW_COVER_FEE_FIELDS, function (v, k) {
    var existingValue = _get(payment, "raisenow.cover_fee.".concat(k)); // don't override if field is already set


    if (payment[v] !== undefined && existingValue === undefined) {
      // todo: refactor with payment team to not cast values
      _set(data, "raisenow.cover_fee.".concat(k), '' + payment[v]);
    }
  });
};

var prepareRnwAnalytics = function prepareRnwAnalytics(data, payment) {
  _each(RNW_ANALYTICS_FIELDS, function (v, k) {
    var existingValue = _get(payment, "raisenow.analytics.".concat(k)); // don't override if field is already set


    if (payment[v] !== undefined && existingValue === undefined) {
      // todo: refactor with payment team to not cast values
      _set(data, "raisenow.analytics.".concat(k), '' + payment[v]);
    }
  });
};

var prepareCustomParameters = function prepareCustomParameters(data, payment) {
  var _context6;

  // Add fields with "stored_" prefix
  // (except ones with "stored_customer_" prefix and some others)
  // to "custom_parameters"
  var info = _pickBy(payment, function (v, k) {
    return _startsWith(k, 'stored_') && !_startsWith(k, 'stored_customer_');
  });

  info = _omit(info, _concatInstanceProperty(_context6 = []).call(_context6, _toConsumableArray(_values(SUPPORTER_FIELDS)), _toConsumableArray(_values(SUPPORTER_METADATA_FIELDS)), _toConsumableArray(_values(RNW_INTEGRATION_FIELDS)), _toConsumableArray(_values(RNW_PRODUCT_FIELDS)), _toConsumableArray(_values(RNW_COVER_FEE_FIELDS)), _toConsumableArray(_values(RNW_ANALYTICS_FIELDS)), IGNORED_FIELDS));

  _each(info, function (v, k) {
    var key = k.replace(/^stored_/, '');

    var existingValue = _get(data, "custom_parameters.".concat(key)); // don't override if field is already set


    if (v !== undefined && existingValue === undefined) {
      _set(data, "custom_parameters.".concat(key), '' + v);
    }
  });
};

var prepareRecurringInfo = function prepareRecurringInfo(data, payment) {
  if (payment.recurring || payment.stored_pseudo_recurring) {
    var timezone;

    try {
      // not supported in ie11
      timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {// do nothing
    }

    if (!timezone) {
      // use fallback
      timezone = 'Europe/Zurich';
    }

    data.subscription = {
      recurring_interval: payment.recurring_interval,
      timezone: timezone
    };
  }
};

var preparePaymentInfo = function preparePaymentInfo(data, payment) {
  prepareTwint(data, payment);
  prepareStripe(data, payment);
}; ///////////////////////////////////////////////////////////////////////////////


var prepareTwint = function prepareTwint(data, payment) {
  var isTwint = payment.payment_method === PaymentMethod.TWINT;

  if (isTwint) {
    data.payment_method = 'twint';
  }
};

var prepareStripe = function prepareStripe(data, payment) {
  var isStripe = isCreditCardPaymentMethod(payment.payment_method) && payment.payment_provider === PaymentProvider.STRIPE;

  if (isStripe) {
    prepareCcPaymentInformation(data, payment);
  }
}; ///////////////////////////////////////////////////////////////////////////////


var prepareCcPaymentInformation = function prepareCcPaymentInformation(data, payment) {
  var PAYMENT_INFORMATION_FIELDS = {
    cardholder: 'card_holder_name',
    number: 'cardno',
    expiry_month: 'expm',
    expiry_year: 'expy',
    cvv: 'cvv',
    card_token: 'card_token',
    brand_code: 'payment_method'
  };

  _each(PAYMENT_INFORMATION_FIELDS, function (v, k) {
    var existingValue = _get(data, "payment_information.".concat(k)); // don't override if field is already set


    if (payment[v] !== undefined && existingValue === undefined) {
      _set(data, "payment_information.".concat(k), payment[v]);
    }
  });
};

///////////////////////////////////////////////////////////////////////////////
var createAndInjectIframe = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(document, options, targetSelector) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new _Promise(function (resolve) {
              options = options || {};
              var iframe = document.createElement('iframe');

              if (options.name) {
                iframe.setAttribute('name', options.name);
              }

              if (options.src) {
                iframe.setAttribute('src', options.src);
              }

              if (options.style) {
                iframe.setAttribute('style', options.style);
              }

              if (options.hidden === true) {
                iframe.setAttribute('style', 'display: none;');
              }

              iframe.onload = function () {
                if (options && _isFunction(options.onload)) {
                  options.onload(iframe);
                }

                resolve(iframe);
              };

              injectHtmlElement(document, iframe, targetSelector);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createAndInjectIframe(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var createForm = function createForm(document, options) {
  var form = document.createElement('form');
  options = options || {};
  options.target = options.target || '_self';
  options.method = options.method || 'post';
  form.target = options.target;
  form.method = options.method;

  if (options.action) {
    form.action = options.action;
  }

  if (options.hidden === true) {
    form.setAttribute('style', 'display: none;');
  }

  return form;
};
var createAndInjectForm = function createAndInjectForm(document, options, targetSelector) {
  var form = createForm(document, options);
  injectHtmlElement(document, form, targetSelector);
  return form;
};
var injectHtmlElement = function injectHtmlElement(document, element, targetSelector) {
  if (targetSelector) {
    var target = document.querySelector(targetSelector);

    if (!target) {
      throw new Error('Could not inject element, target selector "' + targetSelector + '" is invalid');
    } // clear previous contents


    target.innerHTML = '';
    target.appendChild(element);
  } else {
    document.body.appendChild(element);
  }
};
var fillForm = function fillForm(document, form, data) {
  for (var _key in data) {
    var value = data[_key];
    var input = document.createElement('input');
    input.setAttribute('type', 'text');
    input.setAttribute('name', _key);
    input.setAttribute('placeholder', _key);
    input.setAttribute('value', value);
    form.appendChild(input);
  }
};

var PaymentFlowEpp = /*#__PURE__*/function () {
  function PaymentFlowEpp() {
    _classCallCheck(this, PaymentFlowEpp);
  }

  _createClass(PaymentFlowEpp, [{
    key: "start",
    value: function start(epik, payment, window) {
      return new _Promise(function () {
        _setImmediate( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var url, form;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return epik.events[EpikEventName.SEND_EPP_PAYMENT_START].publish({
                    eppPaymentRequestData: payment
                  });

                case 2:
                  url = epik.config.eppApiUrl + '/epayment/api/step/pay/merchant/' + epik.config.eppApiKey;
                  form = createAndInjectForm(window.document, {
                    target: '_self',
                    method: 'post',
                    action: url,
                    hidden: true
                  });
                  fillForm(window.document, form, payment);
                  form.submit(); // don't resolve here so let form submit

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })));
      });
    }
  }]);

  return PaymentFlowEpp;
}();

var _context;

var PaymentFlow; ///////////////////////////////////////////////////////////////////////////////

(function (PaymentFlow) {
  PaymentFlow["EPP"] = "epp";
  PaymentFlow["EPMS"] = "epms";
})(PaymentFlow || (PaymentFlow = {}));

var EppFlowPaymentMethods = [PaymentMethod.CREDIT_CARD, PaymentMethod.AMERICAN_EXPRESS, PaymentMethod.CYMBA, PaymentMethod.DINERS_CLUB, PaymentMethod.DIRECT_DEBIT, PaymentMethod.DISCOVERY, PaymentMethod.WEBBANKING_INDIA, PaymentMethod.ELEKTRONISCHES_LASTSCHRIFTVERFAHREN, PaymentMethod.ELECTRONIC_PAYMENT_SERVICE, PaymentMethod.JAPANESE_CREDIT_BUREAU, PaymentMethod.MAESTRO, PaymentMethod.MASTER_CARD, PaymentMethod.MASTER_PASS, PaymentMethod.PAYMENT_SLIP, PaymentMethod.PAYMENT_SLIP_WITH_REFERENCE_NUMBER, PaymentMethod.PAY_PAL, PaymentMethod.POST_FINANCE, PaymentMethod.POST_FINANCE_CARD, PaymentMethod.SEPA_ONE, PaymentMethod.SMS, PaymentMethod.SOFORT, PaymentMethod.STRIPE, PaymentMethod.TWINT, PaymentMethod.VISA, PaymentMethod.MPOS, PaymentMethod.SWISS_QR_BILL];

var EpmsFlowPaymentMethods = _concatInstanceProperty(_context = [PaymentMethod.TWINT]).call(_context, _toConsumableArray(CreditCardPaymentMethods));

var getSupportedPaymentFlows = function getSupportedPaymentFlows(paymentMethod) {
  if (!isSupportedPaymentMethod(paymentMethod)) {
    throw new Error('Payment method "' + paymentMethod + '" is not supported');
  }

  var flows = [];

  if (_includes(EppFlowPaymentMethods, paymentMethod)) {
    flows.push(PaymentFlow.EPP);
  }

  if (_includes(EpmsFlowPaymentMethods, paymentMethod)) {
    flows.push(PaymentFlow.EPMS);
  }

  if (flows.length === 0) {
    throw new Error('Payment method "' + paymentMethod + '" is not supported by any payment flow');
  }

  return flows;
};
var createPaymentFlow = function createPaymentFlow(paymentFlow) {
  if (paymentFlow === PaymentFlow.EPP) {
    return new PaymentFlowEpp();
  } else if (paymentFlow === PaymentFlow.EPMS) {
    return new PaymentFlowEpms();
  }

  throw new Error('Payment flow "' + paymentFlow + '" is not supported');
};

var PaymentType; ///////////////////////////////////////////////////////////////////////////////

(function (PaymentType) {
  PaymentType["ONE_TIME"] = "onetime";
  PaymentType["RECURRING"] = "recurring";
})(PaymentType || (PaymentType = {}));

var OneTimePaymentMethods = [PaymentMethod.WEBBANKING_INDIA, PaymentMethod.ELEKTRONISCHES_LASTSCHRIFTVERFAHREN, PaymentMethod.ELECTRONIC_PAYMENT_SERVICE, PaymentMethod.JAPANESE_CREDIT_BUREAU, // cc
PaymentMethod.MAESTRO, // cc
PaymentMethod.MASTER_PASS, PaymentMethod.POST_FINANCE, PaymentMethod.SMS, PaymentMethod.SOFORT, PaymentMethod.TWINT, PaymentMethod.MPOS];
var RecurringPaymentMethods = [PaymentMethod.CREDIT_CARD, PaymentMethod.AMERICAN_EXPRESS, PaymentMethod.CYMBA, PaymentMethod.DINERS_CLUB, PaymentMethod.DISCOVERY, PaymentMethod.MASTER_CARD, PaymentMethod.PAY_PAL, PaymentMethod.POST_FINANCE_CARD, PaymentMethod.SEPA_ONE, PaymentMethod.VISA, PaymentMethod.STRIPE, PaymentMethod.MPOS];
var PseudoRecurringPaymentMethods = [PaymentMethod.DIRECT_DEBIT, PaymentMethod.PAYMENT_SLIP, PaymentMethod.PAYMENT_SLIP_WITH_REFERENCE_NUMBER, PaymentMethod.SWISS_QR_BILL];
var getSupportedPaymentTypes = function getSupportedPaymentTypes(paymentMethod) {
  if (!isSupportedPaymentMethod(paymentMethod)) {
    throw new Error('Payment method "' + paymentMethod + '" is not supported');
  }

  var paymentTypes = [];

  if (_includes(OneTimePaymentMethods, paymentMethod)) {
    paymentTypes.push(PaymentType.ONE_TIME);
  }

  if (_includes(RecurringPaymentMethods, paymentMethod)) {
    paymentTypes.push(PaymentType.RECURRING);
  }

  if (_includes(PseudoRecurringPaymentMethods, paymentMethod)) {
    paymentTypes.push(PaymentType.RECURRING);
  }

  return _uniq(paymentTypes);
};
var isPaymentTypeSupported = function isPaymentTypeSupported(paymentMethod, paymentType) {
  return _includes(getSupportedPaymentTypes(paymentMethod), paymentType);
};

var RecurringInterval;

(function (RecurringInterval) {
  RecurringInterval["DAILY"] = "daily";
  RecurringInterval["WEEKLY"] = "weekly";
  RecurringInterval["MONTHLY"] = "monthly";
  RecurringInterval["QUARTERLY"] = "quarterly";
  RecurringInterval["SEMESTRAL"] = "semestral";
  RecurringInterval["YEARLY"] = "yearly";
})(RecurringInterval || (RecurringInterval = {}));

///////////////////////////////////////////////////////////////////////////////
var SubscriptionStatus;

(function (SubscriptionStatus) {
  SubscriptionStatus["ACTIVE"] = "active";
  SubscriptionStatus["INACTIVE"] = "inactive";
})(SubscriptionStatus || (SubscriptionStatus = {}));

///////////////////////////////////////////////////////////////////////////////
var TransactionStatus;

(function (TransactionStatus) {
  TransactionStatus["SUCCESS"] = "success";
  TransactionStatus["ERROR"] = "error";
  TransactionStatus["CANCEL"] = "cancel";
  TransactionStatus["PENDING"] = "pending";
})(TransactionStatus || (TransactionStatus = {}));

var CronHelper = /*#__PURE__*/function () {
  function CronHelper() {
    _classCallCheck(this, CronHelper);
  }

  _createClass(CronHelper, [{
    key: "getRecurringIntervalExpression",
    value: function getRecurringIntervalExpression(recurringInterval) {
      // Instead of parsing the date string as a regular expression, we
      // could use Intl.DateTimeFormat.prototype.formatToParts(), but
      // Internet Explorer does not support it.
      var dateInZurichParts = new RegExp(/^(\d+).(\d+).(\d+)/).exec(new Date().toLocaleString('de-CH', {
        timeZone: 'Europe/Zurich'
      }).replace(/\u200e/g, '') // IE puts LTR marks every here and there
      );
      var dateInZurich = new Date(_parseInt(dateInZurichParts[3]), _parseInt(dateInZurichParts[2]) - 1, _parseInt(dateInZurichParts[1]));
      var weekday = dateInZurich.getDay();
      var date = dateInZurich.getDate();
      var month = dateInZurich.getMonth() + 1; // format is 'date of moth, month, weekday'

      if (recurringInterval === RecurringInterval.DAILY) {
        return ['*', '*', '*'].join(' ');
      } else if (recurringInterval === RecurringInterval.WEEKLY) {
        return ['*', '*', weekday].join(' ');
      } else if (recurringInterval === RecurringInterval.MONTHLY) {
        return [date, '*', '*'].join(' ');
      } else if (recurringInterval === RecurringInterval.QUARTERLY) {
        var months = this.getMonthsSequence(month, 4).join(',');
        return [date, months, '*'].join(' ');
      } else if (recurringInterval === RecurringInterval.SEMESTRAL) {
        var _months = this.getMonthsSequence(month, 2).join(',');

        return [date, _months, '*'].join(' ');
      } else if (recurringInterval === RecurringInterval.YEARLY) {
        return [date, month, '*'].join(' ');
      }

      return recurringInterval;
    }
  }, {
    key: "getRecurringIntervalName",
    value: function getRecurringIntervalName(expression) {
      var matches = expression.match(/[^\s]+\s+[^\s]+\s+([^\s]+\s+[^\s]+\s+[^\s]+)/);
      var monthMatches;
      var len;

      if (matches) {
        expression = matches[1];
      }

      if (matches = expression.match(/([^\s]+)\s+([^\s]+)\s+([^\s]+)/)) {
        if (matches[1].match(/^\d+|L|\*$/)) {
          if (matches[3].match(/^\d+$/)) {
            return RecurringInterval.WEEKLY;
          } else if (matches[2] === '*') {
            return RecurringInterval.MONTHLY;
          } else {
            if (matches[2].match(/^\d+$/)) {
              return RecurringInterval.YEARLY;
            } else if (monthMatches = matches[2].match(/^(?:\*|\d+)\/(\d+)$/)) {
              if (monthMatches[1] == 3) {
                return RecurringInterval.QUARTERLY;
              }

              if (monthMatches[1] == 6) {
                return RecurringInterval.SEMESTRAL;
              }
            } else {
              len = matches[2].split(',').length;

              if (len == 4) {
                return RecurringInterval.QUARTERLY;
              }

              if (len == 2) {
                return RecurringInterval.SEMESTRAL;
              }
            }
          }
        }
      }
    }
  }, {
    key: "getMonthsSequence",
    value: function getMonthsSequence(startMonth, repeatsInYear) {
      if (startMonth < 1 || startMonth > 12) {
        throw new Error('Invalid start month, must be one of: 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12');
      }

      if (12 % repeatsInYear !== 0) {
        throw new Error('Invalid number of repeats, must be one of: 1, 2, 3, 4, 6');
      }

      var interval = 12 / repeatsInYear;
      var relativeOffset = startMonth - 1;
      var months = [];

      for (var i = 0; i < 12; i += interval) {
        var month = relativeOffset + i;
        var monthBelow12 = month % 12;
        var monthAbove0 = monthBelow12 + 1;
        months.push(monthAbove0);
      }

      return months;
    }
  }]);

  return CronHelper;
}(); ///////////////////////////////////////////////////////////////////////////////

var createCronHelper = function createCronHelper() {
  return new CronHelper();
};

var findDefinedValue = function findDefinedValue() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return _find(values, function (v) {
    return v !== null && v !== undefined && v !== '';
  });
};
var normalizeValues = function normalizeValues(data) {
  if (_isString(data)) {
    try {
      data = decodeURIComponent(data);
    } catch (error) {// do nothing
    }

    if (data.toLowerCase() === 'null') {
      return null;
    }

    if (data.toLowerCase() === 'true') {
      return true;
    }

    if (data.toLowerCase() === 'false') {
      return false;
    }

    if (data.toLowerCase() === 'undefined') {
      return undefined;
    }
  }

  if (_isArray(data)) {
    return _map(data, function (v) {
      return normalizeValues(v);
    });
  }

  if (_isPlainObject(data)) {
    return _reduce(data, function (res, v, k) {
      res[k] = normalizeValues(v);
      return res;
    }, {});
  }

  return data;
};
var cleanBlankFields = function cleanBlankFields(payment) {
  _each(payment, function (v, k) {
    if (v === undefined || v === 'undefined' || v === null || v === 'null') {
      payment[k] = '';
    }
  });
}; ///////////////////////////////////////////////////////////////////////////////

var prepareReturnUrl = function prepareReturnUrl(href) {
  var url = document.createElement('a');
  url.href = href;
  var params = qs.parse(url.search, {
    ignoreQueryPrefix: true
  });
  delete params[EpikQueryParam.VIEW];
  delete params[EpikQueryParam.EPP_TRANSACTION_ID];
  delete params[EpikQueryParam.SUBSCRIPTION_TOKEN];
  delete params[EpikQueryParam.CUSTOMER_TOKEN];
  delete params[EpikQueryParam.EPMS_PAYMENT_UUID];
  delete params[EpikQueryParam.EPMS_SUBSCRIPTION_UUID];
  url.search = qs.stringify(params, {
    addQueryPrefix: true,
    strictNullHandling: true
  });
  return url.href;
};
var updateUrlParams = function updateUrlParams(href, data) {
  var url = document.createElement('a');
  url.href = href;
  var params = qs.parse(url.search, {
    ignoreQueryPrefix: true
  });

  _each(data, function (v, k) {
    params[k] = v;
  });

  url.search = qs.stringify(params, {
    addQueryPrefix: true,
    strictNullHandling: true
  });
  return url.href;
}; ///////////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////////
var getLocationParams = function getLocationParams(router) {
  var _router$getLocation = router.getLocation(),
      search = _router$getLocation.search;

  return qs.parse(search, {
    ignoreQueryPrefix: true
  });
};
var getUpdatedLocation = function getUpdatedLocation(router) {
  return function (args) {
    var _router$getLocation2 = router.getLocation(),
        currentPathname = _router$getLocation2.pathname,
        currentSearch = _router$getLocation2.search,
        currentHash = _router$getLocation2.hash;

    var currentParams = qs.parse(currentSearch, {
      ignoreQueryPrefix: true
    }); // eslint-disable-next-line prefer-const

    var newPathname = args.pathname,
        newParams = args.params,
        newHash = args.hash;

    if (newPathname === undefined) {
      newPathname = currentPathname;
    }

    if (newHash === undefined) {
      newHash = currentHash;
    }

    _each(newParams, function (v, k) {
      currentParams[k] = v;

      if (v === undefined) {
        delete currentParams[k];
      }
    });

    var newSearch = qs.stringify(currentParams, {
      addQueryPrefix: true
    });
    return {
      pathname: newPathname,
      search: newSearch,
      hash: newHash
    };
  };
};
var getUpdatedUrl = function getUpdatedUrl(router) {
  return function (args) {
    var _getUpdatedLocation = getUpdatedLocation(router)(args),
        pathname = _getUpdatedLocation.pathname,
        search = _getUpdatedLocation.search,
        hash = _getUpdatedLocation.hash;

    return pathname + search + hash;
  };
};
var prepareExpirationYear = function prepareExpirationYear(input, flow) {
  var expy = _parseInt(input);

  if (isNaN(expy)) {
    return input;
  } // for epp - YY, for epms - YYYY


  expy = flow === PaymentFlow.EPP && expy > 2000 ? expy - 2000 : expy;
  expy = flow === PaymentFlow.EPMS && expy < 2000 ? expy + 2000 : expy;
  return expy.toString();
};

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { var _context5; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context5 = Object.prototype.toString.call(o)).call(_context5, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
///////////////////////////////////////////////////////////////////////////////
var Eventer = /*#__PURE__*/function () {
  function Eventer() {
    _classCallCheck(this, Eventer);

    _defineProperty(this, "debug", false);

    _defineProperty(this, "listeners", {});

    _defineProperty(this, "responders", {});
  }

  _createClass(Eventer, [{
    key: "emit",
    value: function emit(topic, data) {
      this.emitMessage(topic, this.createPayload(data));
    }
  }, {
    key: "on",
    value: function on(topic, listener) {
      if (!_isFunction(listener)) {
        throw new Error('Event listener must be a function');
      }

      if (!this.listeners[topic]) {
        this.listeners[topic] = [];
      }

      this.listeners[topic].push(listener);
    }
  }, {
    key: "simulate",
    value: function simulate(topic, data) {
      this.receiveMessage(topic, data);
    }
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(topic, data, listener) {
        var respondTo, promise;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(listener && !_isFunction(listener))) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Event listener must be a function');

              case 2:
                respondTo = topic + '-response-' + Date.now();
                promise = this.once(respondTo, listener);
                this.emitMessage(topic, this.createPayload(data, respondTo));
                return _context.abrupt("return", promise);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function request(_x, _x2, _x3) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "respond",
    value: function respond(topic, responder) {
      if (!_isFunction(responder)) {
        throw new Error('Event responder must be a function');
      }

      if (!this.responders[topic]) {
        this.responders[topic] = [];
      }

      this.responders[topic].push(responder);
    }
  }, {
    key: "once",
    value: function () {
      var _once = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(topic, listener) {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new _Promise(function (resolve) {
                  var onceListener = function onceListener(data) {
                    _this.off(topic, onceListener);

                    if (listener) {
                      listener(data, topic);
                    }

                    resolve(data);
                  };

                  _this.on(topic, onceListener);
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function once(_x4, _x5) {
        return _once.apply(this, arguments);
      }

      return once;
    }()
  }, {
    key: "off",
    value: function off(topic, listener) {
      var listeners = this.listeners[topic] || [];
      var responders = this.responders[topic] || [];

      for (var _key in listeners) {
        if (listeners[_key] === listener) {
          var _context3;

          _spliceInstanceProperty(_context3 = this.listeners[topic]).call(_context3, _parseInt(_key), 1);

          return;
        }
      }

      for (var _key2 in responders) {
        if (responders[_key2] === listener) {
          var _context4;

          _spliceInstanceProperty(_context4 = this.responders[topic]).call(_context4, _parseInt(_key2), 1);

          return;
        }
      }
    }
  }, {
    key: "emitMessage",
    value: function emitMessage(topic, payload) {
      this.debug && console.debug('[epik] eventer emit', {
        topic: topic,
        data: _cloneDeep(payload)
      });
      this.notifyListeners(topic, _cloneDeep(payload));
      this.notifyResponders(topic, _cloneDeep(payload));
    }
  }, {
    key: "receiveMessage",
    value: function receiveMessage(topic, payload) {
      this.debug && console.debug('[epik] eventer receive', {
        topic: topic,
        data: _cloneDeep(payload)
      });
      this.notifyListeners(topic, _cloneDeep(payload));
      this.notifyResponders(topic, _cloneDeep(payload));
    }
  }, {
    key: "notifyListeners",
    value: function notifyListeners(topic, payload) {
      var _this$parsePayload = this.parsePayload(payload),
          data = _this$parsePayload.data;

      if (topic !== '*') {
        this.notifyListeners('*', payload);
      }

      var listeners = this.listeners[topic];

      if (listeners) {
        var _iterator = _createForOfIteratorHelper(listeners),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _listener = _step.value;

            _listener(data, topic);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "notifyResponders",
    value: function notifyResponders(topic, payload) {
      var _this2 = this;

      var _this$parsePayload2 = this.parsePayload(payload),
          data = _this$parsePayload2.data,
          respondTo = _this$parsePayload2.respondTo;

      var responders = this.responders[topic];

      if (responders) {
        var _iterator2 = _createForOfIteratorHelper(responders),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _responder = _step2.value;
            var response = void 0;

            try {
              response = _responder(data, topic);
            } catch (error) {
              console.error(error);
            }

            if (respondTo) {
              var _response;

              if ((_response = response) !== null && _response !== void 0 && _response.then) {
                response // eslint-disable-next-line promise/always-return
                .then(function (resolvedResponse) {
                  var _this2$parsePayload = _this2.parsePayload(resolvedResponse),
                      data = _this2$parsePayload.data;

                  _this2.emit(respondTo, data);
                })["catch"](function (error) {
                  console.error(error);

                  _this2.emit(respondTo, {
                    error: error
                  });
                });
              } else {
                var _this$parsePayload3 = this.parsePayload(response),
                    _data = _this$parsePayload3.data;

                this.emit(respondTo, _data);
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }, {
    key: "createPayload",
    value: function createPayload(data, respondTo) {
      if (!_isObject(data)) {
        data = {
          __rawData: data
        };
      }

      if (respondTo) {
        data.__respondTo = respondTo;
      }

      return data;
    }
  }, {
    key: "parsePayload",
    value: function parsePayload(payload) {
      payload = payload || {
        __rawData: null
      };
      var respondTo = payload.__respondTo || null;
      delete payload.__respondTo;
      var data = payload.__rawData || payload.__rawData === null ? payload.__rawData : payload;
      return {
        data: data,
        respondTo: respondTo
      };
    }
  }]);

  return Eventer;
}();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

///////////////////////////////////////////////////////////////////////////////
var Messenger = /*#__PURE__*/function (_Eventer) {
  _inherits(Messenger, _Eventer);

  var _super = _createSuper(Messenger);

  function Messenger() {
    var _this;

    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Messenger);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "postMessageListenerAttached", false);

    var listenTo = args.listenTo,
        emitTo = args.emitTo,
        channel = args.channel,
        label = args.label,
        debug = args.debug;
    _this.listenTo = listenTo || null;
    _this.emitTo = emitTo || null;
    _this.channel = channel || null;
    _this.label = label || null;
    _this.debug = !!debug;

    if (listenTo && listenTo === emitTo) {
      console.error('Messenger received two windows of the same instance, this is probably an error, since you want one window to be your main window and the other to be an iframe');
    }

    _this.postMessageListener = _this.postMessageListener.bind(_assertThisInitialized(_this));

    _this.setupPostMessageListener();

    return _this;
  }

  _createClass(Messenger, [{
    key: "emit",
    value: function emit(topic, data) {
      if (!this.emitTo) {
        return;
      }

      _get$1(_getPrototypeOf(Messenger.prototype), "emit", this).call(this, topic, data);
    }
  }, {
    key: "on",
    value: function on(topic, listener) {
      if (!this.listenTo) {
        return;
      }

      _get$1(_getPrototypeOf(Messenger.prototype), "on", this).call(this, topic, listener);
    }
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(topic, data, listener) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.emitTo || !this.listenTo)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                return _context.abrupt("return", _get$1(_getPrototypeOf(Messenger.prototype), "request", this).call(this, topic, data, listener));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function request(_x, _x2, _x3) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "respond",
    value: function respond(topic, responder) {
      if (!this.emitTo || !this.listenTo) {
        return;
      }

      _get$1(_getPrototypeOf(Messenger.prototype), "respond", this).call(this, topic, responder);
    }
  }, {
    key: "once",
    value: function () {
      var _once = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(topic, listener) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.listenTo) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                return _context2.abrupt("return", _get$1(_getPrototypeOf(Messenger.prototype), "once", this).call(this, topic, listener));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function once(_x4, _x5) {
        return _once.apply(this, arguments);
      }

      return once;
    }()
  }, {
    key: "setupPostMessageListener",
    value: function setupPostMessageListener() {
      if (this.listenTo) {
        if (this.postMessageListenerAttached) {
          throw new Error('Post message listener has already been attached');
        }

        this.listenTo.addEventListener('message', this.postMessageListener);
        this.postMessageListenerAttached = true;
      }
    }
  }, {
    key: "removePostmessageListener",
    value: function removePostmessageListener() {
      if (this.listenTo) {
        this.listenTo.removeEventListener('message', this.postMessageListener);
        this.postMessageListenerAttached = false;
      }
    }
  }, {
    key: "postMessageListener",
    value: function postMessageListener(event) {
      try {
        if (event.data) {
          var data = JSON.parse(event.data || '') || {};
          var message = this.createPostMessage(data.channel, data.topic, data.data);
          this.receivePostMessage(message);
        }
      } catch (err) {// throw new Error('Could not handle message, got error: ' + err.toString())
      }
    }
  }, {
    key: "emitMessage",
    value: function emitMessage(topic, payload) {
      try {
        var message = this.createPostMessage(this.channel, topic, payload);
        this.emitPostMessage(message);
      } catch (err) {
        throw new Error('Could not emit message, got error: ' + err.toString());
      }
    }
  }, {
    key: "receiveMessage",
    value: function receiveMessage(topic, payload) {
      this.notifyListeners(topic, _cloneDeep(payload));
      this.notifyResponders(topic, _cloneDeep(payload));
    }
  }, {
    key: "receivePostMessage",
    value: function receivePostMessage(message) {
      if (message && message.topic === null) {
        return;
      }

      if (message.channel !== this.channel) {
        return;
      }

      this.debug && console.debug('[epik] messenger ' + (this.label || '') + ' receive', _cloneDeep(message));
      this.receiveMessage(message.topic, message.data);
    }
  }, {
    key: "emitPostMessage",
    value: function emitPostMessage(message) {
      if (!this.emitTo) {
        throw new Error('Can not emit, emit target has not been set');
      }

      try {
        this.debug && console.debug('[epik] messenger ' + (this.label || '') + ' emit', _cloneDeep(message));
        this.emitTo.postMessage(_JSON$stringify(message), '*');
      } catch (err) {
        throw new Error('Could not send message, got error: ' + err.toString());
      }
    }
  }, {
    key: "createPostMessage",
    value: function createPostMessage(channel, topic, payload) {
      channel = channel || null;
      topic = topic || null;
      var message = {
        channel: channel,
        topic: topic,
        data: payload
      };
      return message;
    }
  }]);

  return Messenger;
}(Eventer);

function ownKeys$2(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

///////////////////////////////////////////////////////////////////////////////
var EppApiProxy = /*#__PURE__*/function () {
  function EppApiProxy(args) {
    _classCallCheck(this, EppApiProxy);

    var epik = args.epik;
    this.epik = epik;
  }

  _createClass(EppApiProxy, [{
    key: "fetchTransaction",
    value: function () {
      var _fetchTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        var _context;

        var eppApiKey, eppTransactionId, _yield$this$sendReque, data;

        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                eppApiKey = args.eppApiKey, eppTransactionId = args.eppTransactionId;
                _context2.next = 3;
                return this.sendRequest({
                  method: 'get',
                  url: _concatInstanceProperty(_context = "/organisations/".concat(eppApiKey, "/transactions/")).call(_context, eppTransactionId)
                });

              case 3:
                _yield$this$sendReque = _context2.sent;
                data = _yield$this$sendReque.data;
                data = normalizeValues(data);
                return _context2.abrupt("return", data);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchTransaction(_x) {
        return _fetchTransaction.apply(this, arguments);
      }

      return fetchTransaction;
    }()
  }, {
    key: "fetchSubscription",
    value: function () {
      var _fetchSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args) {
        var _context3;

        var eppApiKey, subscriptionToken, _yield$this$sendReque2, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                eppApiKey = args.eppApiKey, subscriptionToken = args.subscriptionToken;
                _context4.next = 3;
                return this.sendRequest({
                  method: 'get',
                  url: _concatInstanceProperty(_context3 = "/organisations/".concat(eppApiKey, "/subscriptions/")).call(_context3, subscriptionToken)
                });

              case 3:
                _yield$this$sendReque2 = _context4.sent;
                data = _yield$this$sendReque2.data;
                data = normalizeValues(data);
                return _context4.abrupt("return", data);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchSubscription(_x2) {
        return _fetchSubscription.apply(this, arguments);
      }

      return fetchSubscription;
    }()
  }, {
    key: "fetchCustomer",
    value: function () {
      var _fetchCustomer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(args) {
        var _context5;

        var eppApiKey, customerToken, _yield$this$sendReque3, data;

        return _regeneratorRuntime.wrap(function _callee3$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                eppApiKey = args.eppApiKey, customerToken = args.customerToken;
                _context6.next = 3;
                return this.sendRequest({
                  method: 'get',
                  url: _concatInstanceProperty(_context5 = "/organisations/".concat(eppApiKey, "/customers/")).call(_context5, customerToken)
                });

              case 3:
                _yield$this$sendReque3 = _context6.sent;
                data = _yield$this$sendReque3.data;
                data = normalizeValues(data);
                return _context6.abrupt("return", data);

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchCustomer(_x3) {
        return _fetchCustomer.apply(this, arguments);
      }

      return fetchCustomer;
    }()
  }, {
    key: "cancelSubscription",
    value: function () {
      var _cancelSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(args) {
        var _context7;

        var eppApiKey, subscriptionToken, _yield$this$sendReque4, data;

        return _regeneratorRuntime.wrap(function _callee4$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                eppApiKey = args.eppApiKey, subscriptionToken = args.subscriptionToken;
                _context8.next = 3;
                return this.sendRequest({
                  method: 'post',
                  url: _concatInstanceProperty(_context7 = "/organisations/".concat(eppApiKey, "/subscriptions/")).call(_context7, subscriptionToken, "/cancel")
                });

              case 3:
                _yield$this$sendReque4 = _context8.sent;
                data = _yield$this$sendReque4.data;
                data = normalizeValues(data);
                return _context8.abrupt("return", data);

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee4, this);
      }));

      function cancelSubscription(_x4) {
        return _cancelSubscription.apply(this, arguments);
      }

      return cancelSubscription;
    }()
  }, {
    key: "updateCustomer",
    value: function () {
      var _updateCustomer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(args) {
        var _context9;

        var eppApiKey, customerToken, fields, _yield$this$sendReque5, data;

        return _regeneratorRuntime.wrap(function _callee5$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                eppApiKey = args.eppApiKey, customerToken = args.customerToken, fields = args.fields;
                _context10.next = 3;
                return this.sendRequest({
                  method: 'post',
                  url: _concatInstanceProperty(_context9 = "/organisations/".concat(eppApiKey, "/customers/")).call(_context9, customerToken),
                  data: fields
                });

              case 3:
                _yield$this$sendReque5 = _context10.sent;
                data = _yield$this$sendReque5.data;
                data = normalizeValues(data);
                return _context10.abrupt("return", data);

              case 7:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee5, this);
      }));

      function updateCustomer(_x5) {
        return _updateCustomer.apply(this, arguments);
      }

      return updateCustomer;
    }()
  }, {
    key: "fetchReferenceNumber",
    value: function () {
      var _fetchReferenceNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(args) {
        var _context11;

        var eppApiKey, _args$eppMerchantId, eppMerchantId, campaignId, url, _yield$this$sendReque6, data, _normalizeValues, refno;

        return _regeneratorRuntime.wrap(function _callee6$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                eppApiKey = args.eppApiKey, _args$eppMerchantId = args.eppMerchantId, eppMerchantId = _args$eppMerchantId === void 0 ? '' : _args$eppMerchantId, campaignId = args.campaignId;
                url = campaignId ? _concatInstanceProperty(_context11 = "/organisations/".concat(eppApiKey, "/payment-slips/")).call(_context11, campaignId) : "/organisations/".concat(eppApiKey, "/payment-slips");
                _context12.next = 4;
                return this.sendRequest({
                  method: 'get',
                  url: url,
                  params: {
                    merchant_id: eppMerchantId
                  }
                });

              case 4:
                _yield$this$sendReque6 = _context12.sent;
                data = _yield$this$sendReque6.data;
                _normalizeValues = normalizeValues(data), refno = _normalizeValues.refno;
                return _context12.abrupt("return", refno);

              case 8:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee6, this);
      }));

      function fetchReferenceNumber(_x6) {
        return _fetchReferenceNumber.apply(this, arguments);
      }

      return fetchReferenceNumber;
    }()
  }, {
    key: "sendRequest",
    value: function sendRequest(config) {
      var baseUrl = this.epik.config.eppProxyUrl;
      var url = baseUrl + config.url;
      return axios.request(_objectSpread$2(_objectSpread$2({}, config), {}, {
        url: url
      }));
    }
  }]);

  return EppApiProxy;
}(); ///////////////////////////////////////////////////////////////////////////////

var createEppApiProxy = function createEppApiProxy(args) {
  return new EppApiProxy(args);
};

function ownKeys$1(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
///////////////////////////////////////////////////////////////////////////////
var EpmsApiProxy = /*#__PURE__*/function () {
  function EpmsApiProxy(args) {
    _classCallCheck(this, EpmsApiProxy);

    var epik = args.epik;
    this.epik = epik;
  }

  _createClass(EpmsApiProxy, [{
    key: "fetchPayment",
    value: function () {
      var _fetchPayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        var epmsPaymentUuid, _yield$this$sendReque, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                epmsPaymentUuid = args.epmsPaymentUuid;
                _context.next = 3;
                return this.sendRequest({
                  method: 'get',
                  url: "/epms/payments/".concat(epmsPaymentUuid)
                });

              case 3:
                _yield$this$sendReque = _context.sent;
                data = _yield$this$sendReque.data;
                return _context.abrupt("return", data);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchPayment(_x) {
        return _fetchPayment.apply(this, arguments);
      }

      return fetchPayment;
    }()
  }, {
    key: "fetchPaymentStatus",
    value: function () {
      var _fetchPaymentStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args) {
        var _context2;

        var epmsPaymentUuid, baseUrl, _yield$axios$request, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                epmsPaymentUuid = args.epmsPaymentUuid;
                baseUrl = this.epik.config.epmsApiUrl;
                _context3.next = 4;
                return axios.request({
                  method: 'get',
                  url: _concatInstanceProperty(_context2 = "".concat(baseUrl, "/statuses/payments/")).call(_context2, epmsPaymentUuid)
                });

              case 4:
                _yield$axios$request = _context3.sent;
                data = _yield$axios$request.data;
                return _context3.abrupt("return", data);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchPaymentStatus(_x2) {
        return _fetchPaymentStatus.apply(this, arguments);
      }

      return fetchPaymentStatus;
    }()
  }, {
    key: "fetchSubscription",
    value: function () {
      var _fetchSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(args) {
        var epmsSubscriptionUuid, _yield$this$sendReque2, data;

        return _regeneratorRuntime.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                epmsSubscriptionUuid = args.epmsSubscriptionUuid;
                _context4.next = 3;
                return this.sendRequest({
                  method: 'get',
                  url: "/epms/subscriptions/".concat(epmsSubscriptionUuid)
                });

              case 3:
                _yield$this$sendReque2 = _context4.sent;
                data = _yield$this$sendReque2.data;
                return _context4.abrupt("return", data);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchSubscription(_x3) {
        return _fetchSubscription.apply(this, arguments);
      }

      return fetchSubscription;
    }()
  }, {
    key: "fetchPaymentSource",
    value: function () {
      var _fetchPaymentSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(args) {
        var epmsPaymentSourceUuid, _yield$this$sendReque3, data;

        return _regeneratorRuntime.wrap(function _callee4$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                epmsPaymentSourceUuid = args.epmsPaymentSourceUuid;
                _context5.next = 3;
                return this.sendRequest({
                  method: 'get',
                  url: "/epms/payment-sources/".concat(epmsPaymentSourceUuid)
                });

              case 3:
                _yield$this$sendReque3 = _context5.sent;
                data = _yield$this$sendReque3.data;
                return _context5.abrupt("return", data);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee4, this);
      }));

      function fetchPaymentSource(_x4) {
        return _fetchPaymentSource.apply(this, arguments);
      }

      return fetchPaymentSource;
    }()
  }, {
    key: "fetchPaymentBySubscriptionUuid",
    value: function () {
      var _fetchPaymentBySubscriptionUuid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(args) {
        var epmsSubscriptionUuid, _yield$this$sendReque4, data;

        return _regeneratorRuntime.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                epmsSubscriptionUuid = args.epmsSubscriptionUuid;
                _context6.next = 3;
                return this.sendRequest({
                  method: 'get',
                  url: "/epms/payments/get-by-subscription-uuid/".concat(epmsSubscriptionUuid)
                });

              case 3:
                _yield$this$sendReque4 = _context6.sent;
                data = _yield$this$sendReque4.data;
                return _context6.abrupt("return", data);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchPaymentBySubscriptionUuid(_x5) {
        return _fetchPaymentBySubscriptionUuid.apply(this, arguments);
      }

      return fetchPaymentBySubscriptionUuid;
    }()
  }, {
    key: "cancelPayment",
    value: function () {
      var _cancelPayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(args) {
        var _context7;

        var epmsPaymentUuid, baseUrl;
        return _regeneratorRuntime.wrap(function _callee6$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                epmsPaymentUuid = args.epmsPaymentUuid;
                baseUrl = this.epik.config.epmsApiUrl;
                _context8.next = 4;
                return axios.request({
                  method: 'get',
                  url: _concatInstanceProperty(_context7 = "".concat(baseUrl, "/return/")).call(_context7, epmsPaymentUuid)
                });

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee6, this);
      }));

      function cancelPayment(_x6) {
        return _cancelPayment.apply(this, arguments);
      }

      return cancelPayment;
    }()
  }, {
    key: "cancelSubscription",
    value: function () {
      var _cancelSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(args) {
        var epmsSubscriptionUuid;
        return _regeneratorRuntime.wrap(function _callee7$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                epmsSubscriptionUuid = args.epmsSubscriptionUuid;
                _context9.next = 3;
                return this.sendRequest({
                  method: 'post',
                  url: "/epms/subscriptions/".concat(epmsSubscriptionUuid, "/cancel")
                });

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee7, this);
      }));

      function cancelSubscription(_x7) {
        return _cancelSubscription.apply(this, arguments);
      }

      return cancelSubscription;
    }()
  }, {
    key: "updateSubscription",
    value: function () {
      var _updateSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(args) {
        var epmsSubscriptionUuid, update;
        return _regeneratorRuntime.wrap(function _callee8$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                epmsSubscriptionUuid = args.epmsSubscriptionUuid, update = args.update;
                _context10.next = 3;
                return this.sendRequest({
                  method: 'patch',
                  url: "/epms/subscriptions/".concat(epmsSubscriptionUuid),
                  data: update
                });

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee8, this);
      }));

      function updateSubscription(_x8) {
        return _updateSubscription.apply(this, arguments);
      }

      return updateSubscription;
    }()
  }, {
    key: "sendRequest",
    value: function sendRequest(config) {
      var baseUrl = this.epik.config.epmsProxyUrl;
      var url = baseUrl + config.url;
      return axios.request(_objectSpread$1(_objectSpread$1({}, config), {}, {
        url: url
      }));
    }
  }]);

  return EpmsApiProxy;
}(); ///////////////////////////////////////////////////////////////////////////////

var createEpmsApiProxy = function createEpmsApiProxy(args) {
  return new EpmsApiProxy(args);
};

///////////////////////////////////////////////////////////////////////////////
var createEpikConfig = function createEpikConfig() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  config = _cloneDeep(config) || {};
  var eppApiKeyDefault = "1234567890";
  config.debug = findDefinedValue(config.debug, false);
  config.eppApiKey = findDefinedValue(config.eppApiKey, eppApiKeyDefault);
  config.eppEnv = findDefinedValue(config.eppEnv, 'prod');
  config.epmsEnv = findDefinedValue(config.epmsEnv, 'prod'); /////////////////////////////////////////////////////////////////////////////

  var eppApiUrlStage = "https://api.stage.raisenow.net";
  var eppApiUrlProd = "https://payment.raisenow.com";
  var eppApiUrl = config.eppEnv === 'stage' ? eppApiUrlStage : eppApiUrlProd;
  config.eppApiUrl = findDefinedValue(config.eppApiUrl, eppApiUrl); /////////////////////////////////////////////////////////////////////////////

  var epmsApiUrlStage = "https://api.stage.mesos.raisenow.net";
  var epmsApiUrlProd = "https://api.raisenow.io";
  var epmsApiUrl = config.epmsEnv === 'stage' ? epmsApiUrlStage : epmsApiUrlProd;
  config.epmsApiUrl = findDefinedValue(config.epmsApiUrl, epmsApiUrl); /////////////////////////////////////////////////////////////////////////////

  var eppProxyUrlStage = "https://widget-api.stage.mesos.raisenow.net";
  var eppProxyUrlProd = "https://widget-api.raisenow.com";
  var eppProxyUrl = config.eppEnv === 'stage' ? eppProxyUrlStage : eppProxyUrlProd;
  config.eppProxyUrl = findDefinedValue(config.eppProxyUrl, eppProxyUrl); /////////////////////////////////////////////////////////////////////////////

  var epmsProxyUrlStage = "https://widget-api.stage.mesos.raisenow.net";
  var epmsProxyUrlProd = "https://widget-api.raisenow.com";
  var epmsProxyUrl = config.epmsEnv === 'stage' ? epmsProxyUrlStage : epmsProxyUrlProd;
  config.epmsProxyUrl = findDefinedValue(config.epmsProxyUrl, epmsProxyUrl); /////////////////////////////////////////////////////////////////////////////

  var creditCardIframeUrlStage = "https://api.stage.raisenow.net/cc-iframe/latest/index.html";
  var creditCardIframeUrlProd = "https://payment.raisenow.com/cc-iframe/latest/index.html";
  var creditCardIframeUrl = config.eppEnv === 'stage' ? creditCardIframeUrlStage : creditCardIframeUrlProd;
  config.creditCardIframeUrl = findDefinedValue(config.creditCardIframeUrl, creditCardIframeUrl); /////////////////////////////////////////////////////////////////////////////

  config.testMode = findDefinedValue(config.testMode, true);
  config.language = findDefinedValue(config.language, 'en');
  config.reqtype = findDefinedValue(config.reqtype, 'CAA');
  config.furtherRnwInteraction = findDefinedValue(config.furtherRnwInteraction, false);
  config.returnParameters = findDefinedValue(config.returnParameters, false);
  config.creditCardIframeTargetSelector = config.creditCardIframeTargetSelector || null;
  config.paymentStatusPollForceRequestsCount = findDefinedValue(config.paymentStatusPollForceRequestsCount, 5);
  config.paymentStatusPollInterval = findDefinedValue(config.paymentStatusPollInterval, 1000);
  config.skipCvv = findDefinedValue(config.skipCvv, false);
  config.requireSwissQrBillReferenceNumber = findDefinedValue(config.requireSwissQrBillReferenceNumber, false);
  config.autoFetchReferenceNumber = findDefinedValue(config.autoFetchReferenceNumber, false);
  return config;
};

///////////////////////////////////////////////////////////////////////////////
var Payment = /*#__PURE__*/function () {
  function Payment(epik) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Payment);

    this.epik = epik;
    this.config = config;
  }

  _createClass(Payment, [{
    key: "update",
    value: function update(config) {
      this.config = _merge(this.config, config);
    }
  }, {
    key: "replace",
    value: function replace(config) {
      this.config = _cloneDeep(config);
    }
  }, {
    key: "read",
    value: function read() {
      return _cloneDeep(this.config);
    }
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.epik.sendPayment(this.config, this.creditCardIframe));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function send() {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "markAllFieldsAsTouched",
    value: function markAllFieldsAsTouched() {
      if (this.creditCardIframe) {
        var messenger = this.creditCardIframe.messenger;
        messenger.emit(CreditCardIframeMessageType.MARK_ALL_FIELDS_AS_TOUCHED);
      }
    }
  }, {
    key: "validate",
    value: function () {
      var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.epik.validatePayment(this.config, this.creditCardIframe));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function validate() {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
  }, {
    key: "showCreditCardIframe",
    value: function () {
      var _showCreditCardIframe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(targetSelector, url) {
        var _this$epik$config, creditCardIframeUrl, creditCardIframeTargetSelector, flow, iframeUrl;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.creditCardIframe) {
                  this.hideCreditCardIframe();
                }

                _this$epik$config = this.epik.config, creditCardIframeUrl = _this$epik$config.creditCardIframeUrl, creditCardIframeTargetSelector = _this$epik$config.creditCardIframeTargetSelector;
                flow = this.config.flow;
                targetSelector = findDefinedValue(targetSelector, creditCardIframeTargetSelector);
                iframeUrl = findDefinedValue(url, creditCardIframeUrl);
                _context3.next = 7;
                return this.epik.createCreditCardIframe(targetSelector, iframeUrl, flow);

              case 7:
                this.creditCardIframe = _context3.sent;
                return _context3.abrupt("return", this.creditCardIframe);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function showCreditCardIframe(_x, _x2) {
        return _showCreditCardIframe.apply(this, arguments);
      }

      return showCreditCardIframe;
    }()
  }, {
    key: "hideCreditCardIframe",
    value: function hideCreditCardIframe() {
      if (this.creditCardIframe) {
        var _this$creditCardIfram = this.creditCardIframe,
            iframe = _this$creditCardIfram.iframe,
            messenger = _this$creditCardIfram.messenger;
        messenger.removePostmessageListener();
        iframe.parentNode.removeChild(iframe);
        this.creditCardIframe = null;
      }
    }
  }]);

  return Payment;
}(); ///////////////////////////////////////////////////////////////////////////////

var createPayment = function createPayment(epik, payment) {
  return new Payment(epik, payment);
};

var PaymentPreparator = /*#__PURE__*/function () {
  function PaymentPreparator() {
    _classCallCheck(this, PaymentPreparator);
  }

  _createClass(PaymentPreparator, [{
    key: "prepareMetadata",
    value: function prepareMetadata(payment, epik) {
      var relevantFields = ['flow', 'payment_method', 'currency', 'amount', 'test_mode', 'mobile_mode', 'language', 'reqtype', 'further_rnw_interaction', 'return_parameters', 'subscription_token', 'epms_subscription_uuid', 'recaptcha', 'success_url', 'error_url', 'cancel_url', 'country_code'];
      payment.flow = findDefinedValue(payment.flow, PaymentFlow.EPP);

      if (payment.flow === PaymentFlow.EPMS) {
        relevantFields.push('profile', 'return_url', 'create_supporter', 'supporter', 'raisenow', 'custom_parameters', 'payment_information');
      }

      if (payment.payment_provider == PaymentProvider.INGCOLLECT) {
        payment.country_code = payment.stored_customer_country;
      }

      payment.test_mode = findDefinedValue(payment.test_mode, epik.config.testMode, true);
      payment.mobile_mode = false;
      payment.language = findDefinedValue(payment.language, epik.config.language);
      payment.reqtype = findDefinedValue(payment.reqtype, epik.config.reqtype);
      payment.further_rnw_interaction = findDefinedValue(payment.further_rnw_interaction, epik.config.furtherRnwInteraction) ? 'enabled' : 'disabled';
      payment.return_parameters = findDefinedValue(payment.return_parameters, epik.config.returnParameters, false); // for epp

      payment.success_url = prepareReturnUrl(findDefinedValue(epik.config.successUrl, epik.window.location.href));
      payment.error_url = prepareReturnUrl(findDefinedValue(epik.config.errorUrl, epik.window.location.href));
      payment.cancel_url = prepareReturnUrl(findDefinedValue(epik.config.cancelUrl, epik.window.location.href)); // todo: remove it when backend make this parameter not mandatory
      // for epms

      payment.return_url = prepareReturnUrl(findDefinedValue(payment.return_url, epik.window.location.href));
      var params = {};

      if (payment.subscription_token || payment.epms_subscription_uuid) {
        params[EpikQueryParam.VIEW] = 'subscription_payment_method_update_result';
      } else {
        params[EpikQueryParam.VIEW] = 'payment_result';
      }

      payment.success_url = updateUrlParams(payment.success_url, params);
      payment.error_url = updateUrlParams(payment.error_url, params);
      payment.cancel_url = updateUrlParams(payment.cancel_url, params); // todo: remove it when backend make this parameter not mandatory

      payment.return_url = updateUrlParams(payment.return_url, params);
      return relevantFields;
    }
  }, {
    key: "prepareHmac",
    value: function prepareHmac(payment) {
      var relevantFields = [];

      if (payment.hmac) {
        relevantFields.push('hmac');
      }

      return relevantFields;
    }
  }, {
    key: "prepareRecurring",
    value: function prepareRecurring(payment, epik) {
      var relevantFields = [];
      var isRecurring = false;
      var isPseudoRecurring = false;

      if (payment.recurring || payment.stored_pseudo_recurring) {
        isRecurring = _includesInstanceProperty(RecurringPaymentMethods).call(RecurringPaymentMethods, payment.payment_method);
        isPseudoRecurring = _includesInstanceProperty(PseudoRecurringPaymentMethods).call(PseudoRecurringPaymentMethods, payment.payment_method);
      }

      if (isRecurring) {
        relevantFields.push('recurring');
        payment.recurring = true;
      }

      if (isPseudoRecurring) {
        relevantFields.push('stored_pseudo_recurring');
        payment.stored_pseudo_recurring = true;
      }

      if (isRecurring || isPseudoRecurring) {
        relevantFields.push('recurring_interval', 'stored_rnw_recurring_interval_name', 'stored_customer_email', 'immediate_execution');

        if (payment.recurring_interval) {
          payment.recurring_interval = epik.cronHelper.getRecurringIntervalExpression(payment.recurring_interval);
        }

        if (!_isBoolean(payment.immediate_execution)) {
          payment.immediate_execution = true;
        }
      }

      return relevantFields;
    }
  }, {
    key: "prepareCreditCard",
    value: function () {
      var _prepareCreditCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payment, epik, creditCardIframe) {
        var relevantFields, skipCvv, hasCardHolderName, hasFirstAndLastName, hasRawName, hasCardNumber, hasExpirationYear;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                relevantFields = [];

                if (!isCreditCardPaymentMethod(payment.payment_method)) {
                  _context.next = 16;
                  break;
                }

                relevantFields.push('card_holder_name', 'payment_provider', 'create_payment_source');
                skipCvv = !!epik.config.skipCvv;
                hasCardHolderName = !!payment.card_holder_name;
                hasFirstAndLastName = !!payment.stored_customer_firstname && !!payment.stored_customer_lastname;
                hasRawName = !!payment.stored_customer_raw_name;

                if (!hasCardHolderName) {
                  if (hasFirstAndLastName) {
                    payment.card_holder_name = payment.stored_customer_firstname + ' ' + payment.stored_customer_lastname;
                  } else if (hasRawName) {
                    payment.card_holder_name = payment.stored_customer_raw_name;
                  }
                }

                if (!creditCardIframe) {
                  _context.next = 13;
                  break;
                }

                relevantFields.push('card_token');
                _context.next = 12;
                return epik.acquireCreditCardTokenFromIframe(creditCardIframe);

              case 12:
                payment.card_token = _context.sent;

              case 13:
                if (!creditCardIframe) {
                  relevantFields.push('cardno', 'expm', 'expy');

                  if (!skipCvv) {
                    relevantFields.push('cvv');
                  }

                  hasCardNumber = !!payment.cardno;
                  hasExpirationYear = !!payment.expy;

                  if (hasCardNumber) {
                    payment.cardno = payment.cardno.replace(/[A-z\s-]+/g, '');
                  }

                  if (hasExpirationYear) {
                    payment.expy = prepareExpirationYear(payment.expy, payment.flow);
                  }
                }

                _context.next = 16;
                return this.autodetectAndSetCreditCardPaymentMethod(payment, epik, creditCardIframe);

              case 16:
                return _context.abrupt("return", relevantFields);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function prepareCreditCard(_x, _x2, _x3) {
        return _prepareCreditCard.apply(this, arguments);
      }

      return prepareCreditCard;
    }()
  }, {
    key: "autodetectAndSetCreditCardPaymentMethod",
    value: function () {
      var _autodetectAndSetCreditCardPaymentMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payment, epik, creditCardIframe) {
        var isStripe, isEpp, paymentMethod;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isStripe = payment.payment_provider === PaymentProvider.STRIPE;
                isEpp = payment.flow === PaymentFlow.EPP;

                if (!(isStripe && isEpp)) {
                  _context2.next = 5;
                  break;
                }

                payment.payment_method = PaymentMethod.STRIPE;
                return _context2.abrupt("return");

              case 5:
                if (!creditCardIframe) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 8;
                return epik.acquireCreditCardTypeFromIframe(creditCardIframe);

              case 8:
                paymentMethod = _context2.sent;

              case 9:
                if (!creditCardIframe) {
                  if (payment.cardno) {
                    paymentMethod = getCreditCardType(payment.cardno);
                  }
                }

                if (!paymentMethod) {
                  paymentMethod = FallbackCreditCardPaymentMethod;
                }

                payment.payment_method = paymentMethod;

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function autodetectAndSetCreditCardPaymentMethod(_x4, _x5, _x6) {
        return _autodetectAndSetCreditCardPaymentMethod.apply(this, arguments);
      }

      return autodetectAndSetCreditCardPaymentMethod;
    }()
  }, {
    key: "prepareDirectDebit",
    value: function prepareDirectDebit(payment) {
      var relevantFields = [];
      var isDirectDebit = payment.payment_method === PaymentMethod.DIRECT_DEBIT;

      if (isDirectDebit) {
        relevantFields.push('iban', 'bankbic', 'bank_name', 'bank_city', 'bank_zip_code', 'form_template');
      }

      return relevantFields;
    }
  }, {
    key: "prepareElv",
    value: function prepareElv(payment) {
      var relevantFields = [];
      var isElv = payment.payment_method === PaymentMethod.ELEKTRONISCHES_LASTSCHRIFTVERFAHREN;

      if (isElv) {
        relevantFields.push('bankiban');
      }

      return relevantFields;
    }
  }, {
    key: "prepareSepaOne",
    value: function prepareSepaOne(payment) {
      var relevantFields = [];
      var isSepaOne = payment.payment_method === PaymentMethod.SEPA_ONE;

      if (isSepaOne) {
        relevantFields.push('bankiban', 'bankbic');
      }

      return relevantFields;
    }
  }, {
    key: "preparePaymentSlip",
    value: function () {
      var _preparePaymentSlip = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payment, epik) {
        var relevantFields, isEs, isEzs, isChqr, requireChqrRefno, autoFetchRefno, hasPayerLine1, hasPayerLine2, hasPayerLine3, hasPayerLine4, hasAnyPayerLine, hasRefno, hasCompany, hasFirstAndLastName, hasRawName, _context3, _context4, _context5, _context6, lines, name, address, location;

        return _regeneratorRuntime.wrap(function _callee3$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                relevantFields = [];
                isEs = payment.payment_method === PaymentMethod.PAYMENT_SLIP;
                isEzs = payment.payment_method === PaymentMethod.PAYMENT_SLIP_WITH_REFERENCE_NUMBER;
                isChqr = payment.payment_method === PaymentMethod.SWISS_QR_BILL;
                requireChqrRefno = epik.config.requireSwissQrBillReferenceNumber;
                autoFetchRefno = epik.config.autoFetchReferenceNumber;
                hasPayerLine1 = !!payment.payer_line1;
                hasPayerLine2 = !!payment.payer_line2;
                hasPayerLine3 = !!payment.payer_line3;
                hasPayerLine4 = !!payment.payer_line4;
                hasAnyPayerLine = hasPayerLine1 || hasPayerLine2 || hasPayerLine3 || hasPayerLine4;
                hasRefno = !!payment.refno;
                hasCompany = !!payment.stored_customer_company;
                hasFirstAndLastName = !!payment.stored_customer_firstname && !!payment.stored_customer_lastname;
                hasRawName = !!payment.stored_customer_raw_name;

                if (isEs) {
                  relevantFields.push('stored_es_ordered', 'es_message');
                }

                if (isEzs) {
                  relevantFields.push('stored_ezs_ordered', 'refno');
                }

                if (isChqr) {
                  relevantFields.push('stored_chqr_ordered', 'refno', 'es_message');
                }

                if (isEs || isEzs || isChqr) {
                  relevantFields.push('payer_line1', 'payer_line2', 'payer_line3', 'payer_line4');
                } // If at least one of payer lines fields is provided in the payment object,
                // then we are skipping automatic population of these fields and use provided values instead.
                //
                // So if customer wants to have payer lines in some different format,
                // he must provide all these fields by himself.
                // Following logic should cover most of the customers.


                if ((isEs || isEzs || isChqr) && !hasAnyPayerLine) {
                  lines = [];

                  // Company (optional)
                  if (hasCompany) {
                    lines.push(payment.stored_customer_company);
                  } // Name - "Firstname Lastname"


                  if (hasFirstAndLastName) {
                    name = [payment.stored_customer_firstname, payment.stored_customer_lastname].join(' ');
                  } else if (hasRawName) {
                    name = payment.stored_customer_raw_name;
                  }

                  if (name) {
                    lines.push(name);
                  } // Street - "Dummystreet 42"


                  address = _filterInstanceProperty(_context3 = [payment.stored_customer_street, payment.stored_customer_street_number]).call(_context3, function (v) {
                    return !!v;
                  }).join(' '); // Street with optional P.O. box - "Dummystreet 42 / POBOX"

                  address = _filterInstanceProperty(_context4 = [address, payment.stored_customer_pobox]).call(_context4, function (v) {
                    return !!v;
                  }).join(' / ');

                  if (address) {
                    lines.push(address);
                  } // Location - "CH-8005 Zürich"
                  // eslint-disable-next-line prefer-const


                  location = _concatInstanceProperty(_context5 = _concatInstanceProperty(_context6 = "".concat(payment.stored_customer_country, "-")).call(_context6, payment.stored_customer_zip_code, " ")).call(_context5, payment.stored_customer_city);
                  lines.push(location);
                  lines.forEach(function (line, idx) {
                    payment["payer_line".concat(idx + 1)] = line;
                  });
                }

                if (!(isEzs || isChqr && requireChqrRefno)) {
                  _context7.next = 25;
                  break;
                }

                if (!(!hasRefno && autoFetchRefno)) {
                  _context7.next = 25;
                  break;
                }

                _context7.next = 24;
                return epik.fetchReferenceNumber(payment.stored_campaign_id);

              case 24:
                payment.refno = _context7.sent;

              case 25:
                return _context7.abrupt("return", relevantFields);

              case 26:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee3);
      }));

      function preparePaymentSlip(_x7, _x8) {
        return _preparePaymentSlip.apply(this, arguments);
      }

      return preparePaymentSlip;
    }()
  }, {
    key: "prepareSms",
    value: function prepareSms(payment) {
      var relevantFields = [];
      var isSms = payment.payment_method === PaymentMethod.SMS;
      var hasMsisdn = !!payment.msisdn;

      if (isSms) {
        relevantFields.push('msisdn');

        if (hasMsisdn) {
          payment.msisdn = ('' + payment.msisdn).replace(/\s/g, '');
        } else {
          payment.msisdn = '';
        }
      }

      return relevantFields;
    }
  }, {
    key: "prepareCustomFields",
    value: function prepareCustomFields(payment) {
      // following fields are handled separately so should be ignored here
      var ignore = ['stored_pseudo_recurring', 'stored_payment_slip_delivery_type', 'stored_es_ordered', 'stored_ezs_ordered', 'stored_chqr_ordered'];
      return _filter(_keys(payment), function (k) {
        return _startsWith(k, 'stored_') && !_includesInstanceProperty(ignore).call(ignore, k);
      });
    }
  }]);

  return PaymentPreparator;
}(); ///////////////////////////////////////////////////////////////////////////////

var createPaymentPreparator = function createPaymentPreparator() {
  return new PaymentPreparator();
};

var validateMinLength = function validateMinLength(input, length) {
  return input && input.length >= length;
};
var validateMaxLength = function validateMaxLength(input, length) {
  return input && input.length <= length;
};
var validateLengthBetween = function validateLengthBetween(input, minLength, maxLength) {
  return validateMinLength(input, minLength) && validateMaxLength(input, maxLength);
};
var validateNumerical = function validateNumerical(input) {
  return /^[.\d]+$/.test(input);
};
var validateNumberBetween = function validateNumberBetween(input, min, max) {
  var number = _parseFloat(input);

  return number >= min && number <= max;
};
var validateInRange = function validateInRange(input, range) {
  return _indexOfInstanceProperty(range).call(range, input) !== -1;
};

var validateCreditCardNumber = function validateCreditCardNumber(cardNumber) {
  return validateNumerical(cardNumber) && validateCreditCardLength(cardNumber) && validateCreditCardLuhn(cardNumber);
};
var validateCreditCardLength = function validateCreditCardLength(cardNumber) {
  var type = getCreditCardType(cardNumber);

  if (type === PaymentMethod.AMERICAN_EXPRESS) {
    return _includes([15], cardNumber.length);
  }

  if (type === PaymentMethod.VISA) {
    return _includes([13, 16, 19], cardNumber.length);
  }

  if (type === PaymentMethod.MASTER_CARD) {
    return _includes([16], cardNumber.length);
  }

  if (type === PaymentMethod.DISCOVERY) {
    return _includes([16, 17, 18, 19], cardNumber.length);
  }

  if (type === PaymentMethod.DINERS_CLUB) {
    return _includes([14, 15, 16, 17, 18, 19], cardNumber.length);
  }

  if (type === PaymentMethod.JAPANESE_CREDIT_BUREAU) {
    return _includes([16, 17, 18, 19], cardNumber.length);
  }

  if (type === PaymentMethod.MAESTRO) {
    return _includes([12, 13, 14, 15, 16, 17, 18, 19], cardNumber.length);
  }

  return false;
};
var validateCreditCardLuhn = function validateCreditCardLuhn(cardNumber) {
  var s = 0;
  var doubleDigit = false;

  for (var i = cardNumber.length - 1; i >= 0; i--) {
    var digit = +cardNumber[i];

    if (doubleDigit) {
      digit *= 2;

      if (digit > 9) {
        digit -= 9;
      }
    }

    s += digit;
    doubleDigit = !doubleDigit;
  }

  return s % 10 === 0;
};
var validateCreditCardCvv = function validateCreditCardCvv(input) {
  return validateNumerical(input) && validateLengthBetween(input, 3, 4);
};
var validateCreditCardExpirationMonth = function validateCreditCardExpirationMonth(input) {
  return validateNumberBetween(input, 1, 12);
};
var validateCreditCardExpirationYear = function validateCreditCardExpirationYear(input) {
  var expy = _parseInt(input);

  expy = expy < 100 ? expy + 2000 : expy;
  var currentYear = new Date().getFullYear();
  return validateNumberBetween(expy, currentYear, currentYear + 50);
};

// https://en.wikipedia.org/wiki/International_Bank_Account_Number
var IBAN_FORMATS = {
  // for items below:
  //    kk = represent the IBAN checksum
  //    b = National bank code
  //    s = Branch code
  //    x = National check digit
  //    c = Account number
  //    a - Balance account number
  //    t = Account type
  //    n = Owner account number
  //    m = Currency
  //    i = holder's identification number
  //    0 = Zeroes
  Albania: 'ALkk bbbs sssx cccc cccc cccc cccc',
  Andorra: 'ADkk bbbb ssss cccc cccc cccc',
  Austria: 'ATkk bbbb bccc cccc cccc',
  Azerbaijan: 'AZkk bbbb cccc cccc cccc cccc cccc',
  Bahrain: 'BHkk bbbb cccc cccc cccc cc',
  Belarus: 'BYkk bbbb aaaa cccc cccc cccc cccc',
  Belgium: 'BEkk bbbc cccc ccxx',
  'Bosnia and Herzegovina': 'BAkk bbbs sscc cccc ccxx',
  Brazil: 'BRkk bbbb bbbb ssss sccc cccc ccct n',
  Bulgaria: 'BGkk bbbb ssss ttcc cccc cc',
  'Costa Rica': 'CRkk 0bbb cccc cccc cccc cc',
  Croatia: 'HRkk bbbb bbbc cccc cccc c',
  Cyprus: 'CYkk bbbs ssss cccc cccc cccc cccc',
  'Czech Republic': 'CZkk bbbb ssss sscc cccc cccc',
  Denmark: 'DKkk bbbb cccc cccc cc',
  'Dominican Republic': 'DOkk bbbb cccc cccc cccc cccc cccc',
  'East Timor': 'TLkk bbbc cccc cccc cccc cxx',
  Estonia: 'EEkk bbss cccc cccc cccx',
  'Faroe Islands': 'FOkk bbbb cccc cccc cx',
  Finland: 'FIkk bbbb bbcc cccc cx',
  France: 'FRkk bbbb bsss sscc cccc cccc cxx',
  Georgia: 'GEkk bbcc cccc cccc cccc cc',
  Germany: 'DEkk bbbb bbbb cccc cccc cc',
  Gibraltar: 'GIkk bbbb cccc cccc cccc ccc',
  Greece: 'GRkk bbbs sssc cccc cccc cccc ccc',
  Greenland: 'GLkk bbbb cccc cccc cc',
  Guatemala: 'GTkk bbbb mmtt cccc cccc cccc cccc',
  Hungary: 'HUkk bbbs sssx cccc cccc cccc cccx',
  Iceland: 'ISkk bbbb sscc cccc iiii iiii ii',
  Ireland: 'IEkk aaaa bbbb bbcc cccc cc',
  Israel: 'ILkk bbbn nncc cccc cccc ccc',
  Italy: 'ITkk xbbb bbss sssc cccc cccc ccc',
  Jordan: 'JOkk bbbb ssss cccc cccc cccc cccc cc',
  Kazakhstan: 'KZkk bbbc cccc cccc cccc',
  Kosovo: 'XKkk bbbb cccc cccc cccc',
  Kuwait: 'KWkk bbbb cccc cccc cccc cccc cccc cc',
  Latvia: 'LVkk bbbb cccc cccc cccc c',
  Lebanon: 'LBkk bbbb cccc cccc cccc cccc cccc',
  Liechtenstein: 'LIkk bbbb bccc cccc cccc c',
  Lithuania: 'LTkk bbbb bccc cccc cccc',
  Luxembourg: 'LUkk bbbc cccc cccc cccc',
  Macedonia: 'MKkk bbbc cccc cccc cxx',
  Malta: 'MTkk bbbb ssss sccc cccc cccc cccc ccc',
  Mauritania: 'MRkk bbbb bsss sscc cccc cccc cxx',
  Mauritius: 'MUkk bbbb bbss cccc cccc cccc 000m mm',
  Monaco: 'MCkk bbbb bsss sscc cccc cccc cxx',
  Moldova: 'MDkk bbcc cccc cccc cccc cccc',
  Montenegro: 'MEkk bbbc cccc cccc cccc xx',
  Netherlands: 'NLkk bbbb cccc cccc cc',
  Norway: 'NOkk bbbb cccc ccx',
  Pakistan: 'PKkk bbbb cccc cccc cccc cccc',
  'Palestinian territories': 'PSkk bbbb xxxx xxxx xccc cccc cccc c',
  Poland: 'PLkk bbbs sssx cccc cccc cccc cccc',
  Portugal: 'PTkk bbbb ssss cccc cccc cccx x',
  Qatar: 'QAkk bbbb cccc cccc cccc cccc cccc c',
  Romania: 'ROkk bbbb cccc cccc cccc cccc',
  'San Marino': 'SMkk xbbb bbss sssc cccc cccc ccc',
  'Saudi Arabia': 'SAkk bbcc cccc cccc cccc cccc',
  Serbia: 'RSkk bbbc cccc cccc cccc xx',
  Slovakia: 'SKkk bbbb ssss sscc cccc cccc',
  Slovenia: 'SIkk bbss sccc cccc cxx',
  Spain: 'ESkk bbbb ssss xxcc cccc cccc',
  Sweden: 'SEkk bbbc cccc cccc cccc cccc',
  Switzerland: 'CHkk bbbb bccc cccc cccc c',
  Tunisia: 'TNkk bbss sccc cccc cccc cccc',
  Turkey: 'TRkk bbbb bxcc cccc cccc cccc cc',
  'United Arab Emirates': 'AEkk bbbc cccc cccc cccc ccc',
  'United Kingdom': 'GBkk bbbb ssss sscc cccc cc',
  'Virgin Islands, British': 'VGkk bbbb cccc cccc cccc cccc',
  // for items below:
  //    kk = represent the IBAN checksum
  //    a = represents an alphabetic character
  //    n = represents a numeric character
  //    b = represents a bank code character
  //    c = represents an account digit.
  //    0 = represents a "0" character
  Algeria: 'DZkk nnnn nnnn nnnn nnnn nnnn',
  Angola: 'AOkk nnnn nnnn nnnn nnnn nnnn n',
  Benin: 'BJkk annn nnnn nnnn nnnn nnnn nnnn',
  'Burkina Faso': 'BFkk nnnn nnnn nnnn nnnn nnnn nnnn',
  Burundi: 'BIkk nnnn nnnn nnnn',
  Cameroon: 'CMkk nnnn nnnn nnnn nnnn nnnn nnn',
  'Cape Verde': 'CVkk nnnn nnnn nnnn nnnn nnnn n',
  Iran: 'IRkk 0bb0 nnnn nnnn nnnn nnnn nn',
  'Ivory Coast': 'CIkk annn nnnn nnnn nnnn nnnn nnnn',
  Madagascar: 'MGkk nnnn nnnn nnnn nnnn nnnn nnn',
  Mali: 'MLkk annn nnnn nnnn nnnn nnnn nnnn',
  Mozambique: 'MZkk nnnn nnnn nnnn nnnn nnnn n',
  Senegal: 'SNkk annn nnnn nnnn nnnn nnnn nnnn',
  Ukraine: 'UAkk bbbb bbcc cccc cccc cccc cccc c',
  Comoros: 'KMkk nnnn nnnn nnnn nnnn nnnn nnn',
  Chad: 'TDkk nnnn nnnn nnnn nnnn nnnn nnn',
  Congo: 'CGkk nnnn nnnn nnnn nnnn nnnn nnn',
  Egypt: 'EGkk nnnn nnnn nnnn nnnn nnnn nnn',
  Gabon: 'GAkk nnnn nnnn nnnn nnnn nnnn nnn',
  Honduras: 'HNkk aaaa nnnn nnnn nnnn nnnn nnnn',
  Morocco: 'MAkk nnnn nnnn nnnn nnnn nnnn nnnn',
  Nicaragua: 'NIkk aaaa nnnn nnnn nnnn nnnn nnnn nnnn',
  Niger: 'NEkk aann nnnn nnnn nnnn nnnn nnnn',
  Togo: 'TGkk aann nnnn nnnn nnnn nnnn nnnn'
};

var sanitizeIBAN = function sanitizeIBAN(iban) {
  return (iban || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
};

var getCountryCodeFromIBAN = function getCountryCodeFromIBAN(iban) {
  return (iban || '').substr(0, 2);
};

var getChecksumFromIBAN = function getChecksumFromIBAN(iban) {
  return (iban || '').substr(2, 2);
};

var getAccountNumberFromIBAN = function getAccountNumberFromIBAN(iban) {
  return (iban || '').substr(4);
};

var findFormatForIBAN = function findFormatForIBAN(iban) {
  var countryCode = getCountryCodeFromIBAN(iban);

  for (var countryName in IBAN_FORMATS) {
    var format = IBAN_FORMATS[countryName];

    if (getCountryCodeFromIBAN(format) === countryCode) {
      return IBAN_FORMATS[countryName];
    }
  }

  return null;
};

var checkIBANLength = function checkIBANLength(iban) {
  var ibanFormat = sanitizeIBAN(findFormatForIBAN(iban));
  return iban && ibanFormat && iban.length === ibanFormat.length;
};

var checkIBANChecksum = function checkIBANChecksum(iban) {
  var ibanCountryCode = getCountryCodeFromIBAN(iban);
  var ibanChecksum = getChecksumFromIBAN(iban);
  var ibanNumber = getAccountNumberFromIBAN(iban);
  var reversedIban = ibanNumber + ibanCountryCode + ibanChecksum;
  var ibanInteger = reversedIban.replace(/[A-Z]/g, function (_char) {
    return (_char.charCodeAt(0) - 55).toString();
  });
  var ibanWithoutChecksum = ibanInteger.substr(2);
  var checksum = ibanInteger.substr(0, 2);

  for (var i = 0; i < ibanWithoutChecksum.length; i += 7) {
    var fragment = checksum + ibanWithoutChecksum.substring(i, i + 7);
    checksum = (_parseInt(fragment, 10) % 97).toString();
  }

  return checksum === '1';
};

var validateIBAN = function validateIBAN(input) {
  var iban = sanitizeIBAN(input);
  return checkIBANLength(iban) && checkIBANChecksum(iban);
};

// prettier-ignore
var PaymentError = {
  SUCCESS_URL_MISSING: {
    code: 'success_url_missing',
    message: 'Missing success url'
  },
  ERROR_URL_MISSING: {
    code: 'error_url_missing',
    message: 'Missing error url'
  },
  CANCEL_URL_MISSING: {
    code: 'cancel_url_missing',
    message: 'Missing cancel url'
  },
  TEST_MODE_MISSING: {
    code: 'test_mode_missing',
    message: 'Missing test mode setting'
  },
  TEST_MODE_INVALID: {
    code: 'test_mode_invalid',
    message: 'Invalid value'
  },
  LANGUAGE_MISSING: {
    code: 'language_missing',
    message: 'Missing language setting'
  },
  REQTYPE_MISSING: {
    code: 'reqtype_missing',
    message: 'Missing reqtype setting'
  },
  REQTYPE_INVALID: {
    code: 'reqtype_invalid',
    message: 'Invalid value'
  },
  FURTHER_RNW_INTERACTION_MISSING: {
    code: 'further_rnw_interaction_missing',
    message: 'Missing further interaction setting'
  },
  FURTHER_RNW_INTERACTION_INVALID: {
    code: 'further_rnw_interaction_invalid',
    message: 'Invalid value'
  },
  PAYMENT_METHOD_MISSING: {
    code: 'payment_method_missing',
    message: 'Payment method missing'
  },
  PAYMENT_METHOD_INVALID: {
    code: 'payment_method_invalid',
    message: 'Payment method is not supported'
  },
  PAYMENT_PROVIDER_INVALID: {
    code: 'payment_provider_invalid',
    message: 'Payment provider is not supported'
  },
  RECURRING_INTERVAL_MISSING: {
    code: 'recurring_interval_missing',
    message: 'Recurring interval missing'
  },
  AMOUNT_MISSING: {
    code: 'amount_missing',
    message: 'Amount missing'
  },
  AMOUNT_INVALID: {
    code: 'amount_invalid',
    message: 'Invalid value'
  },
  CURRENCY_MISSING: {
    code: 'currency_missing',
    message: 'Missing currency'
  },
  CARD_HOLDER_NAME_MISSING: {
    code: 'card_holder_name_missing',
    message: 'Missing credit card holder name'
  },
  CARD_TOKEN_MISSING: {
    code: 'card_token_missing',
    message: 'Missing credit card token'
  },
  CARDNO_MISSING: {
    code: 'cardno_missing',
    message: 'Missing credit card number'
  },
  CARDNO_INVALID: {
    code: 'cardno_invalid',
    message: 'Invalid credit card number'
  },
  CVV_MISSING: {
    code: 'cvv_missing',
    message: 'Missing credit card cvv'
  },
  CVV_INVALID: {
    code: 'cvv_invalid',
    message: 'Invalid credit card cvv'
  },
  EXPM_MISSING: {
    code: 'expm_missing',
    message: 'Missing credit card expiration month'
  },
  EXPM_INVALID: {
    code: 'expm_invalid',
    message: 'Invalid credit card expiration month'
  },
  EXPY_MISSING: {
    code: 'expy_missing',
    message: 'Missing credit card expiration year'
  },
  EXPY_INVALID: {
    code: 'expy_invalid',
    message: 'Invalid credit card expiration year'
  },
  STORED_CUSTOMER_FIRSTNAME_MISSING: {
    code: 'stored_customer_firstname_missing',
    message: 'Missing customer first name'
  },
  STORED_CUSTOMER_LASTNAME_MISSING: {
    code: 'stored_customer_lastname_missing',
    message: 'Missing customer last name'
  },
  STORED_CUSTOMER_EMAIL_MISSING: {
    code: 'stored_customer_email_missing',
    message: 'Missing email address'
  },
  STORED_CUSTOMER_STREET_MISSING: {
    code: 'stored_customer_street_missing',
    message: 'Missing customer street'
  },
  STORED_CUSTOMER_ZIP_CODE_MISSING: {
    code: 'stored_customer_zip_code_missing',
    message: 'Missing customer zip code'
  },
  STORED_CUSTOMER_CITY_MISSING: {
    code: 'stored_customer_city_missing',
    message: 'Missing customer city'
  },
  STORED_CUSTOMER_COUNTRY_MISSING: {
    code: 'stored_customer_country_missing',
    message: 'Missing customer country'
  },
  IBAN_MISSING: {
    code: 'iban_missing',
    message: 'Missing bank IBAN'
  },
  IBAN_INVALID: {
    code: 'iban_invalid',
    message: 'Invalid bank IBAN'
  },
  BANKBIC_MISSING: {
    code: 'bankbic_missing',
    message: 'Missing bankbic'
  },
  BANK_NAME_MISSING: {
    code: 'bank_name_missing',
    message: 'Missing bank name'
  },
  BANK_ZIP_CODE_MISSING: {
    code: 'bank_zip_code_missing',
    message: 'Missing bank zip code'
  },
  BANK_CITY_MISSING: {
    code: 'bank_city_missing',
    message: 'Missing bank city'
  },
  STORED_ES_ORDERED_MISSING: {
    code: 'stored_es_ordered_missing',
    message: 'Missing stored_es_ordered'
  },
  STORED_EZS_ORDERED_MISSING: {
    code: 'stored_ezs_ordered_missing',
    message: 'Missing stored_ezs_ordered'
  },
  STORED_CHQR_ORDERED_MISSING: {
    code: 'stored_chqr_ordered_missing',
    message: 'Missing stored_chqr_ordered'
  },
  REFNO_MISSING: {
    code: 'refno_missing',
    message: 'Missing refno'
  },
  MSISDN_MISSING: {
    code: 'msisdn_missing',
    message: 'Missing msisdn'
  },
  MSISDN_INVALID: {
    code: 'msisdn_invalid',
    message: 'Invalid msisdn'
  }
};

///////////////////////////////////////////////////////////////////////////////
var addError = function addError(errors, key, error) {
  if (!_isArray(errors[key])) {
    errors[key] = [];
  }

  errors[key].push(error);
  return errors;
};

var validateMsisdn = function validateMsisdn(input) {
  var format = /^\+417[56789][0-9]{7}$/;
  return format.test(input);
};

var PaymentValidator = /*#__PURE__*/function () {
  function PaymentValidator() {
    _classCallCheck(this, PaymentValidator);
  }

  _createClass(PaymentValidator, [{
    key: "validateMetadata",
    value: function validateMetadata(payment) {
      var _context;

      var errors = {};
      var hasSuccessUrl = !!payment.success_url;
      var hasErrorUrl = !!payment.error_url;
      var hasCancelUrl = !!payment.cancel_url;

      var hasTestMode = _includesInstanceProperty(_context = _keys(payment)).call(_context, 'test_mode');

      var isValidTestMode = validateInRange(payment.test_mode, [true, false]);
      var hasLanguage = !!payment.language;
      var hasReqtype = !!payment.reqtype;
      var isValidReqtype = payment.reqtype === 'CAA';
      var hasFurtherRnwInteraction = !!payment.further_rnw_interaction;
      var isValidFurtherRnwInteraction = validateInRange(payment.further_rnw_interaction, ['enabled', 'disabled']);

      if (!hasSuccessUrl) {
        addError(errors, 'success_url', PaymentError.SUCCESS_URL_MISSING);
      }

      if (!hasErrorUrl) {
        addError(errors, 'error_url', PaymentError.ERROR_URL_MISSING);
      }

      if (!hasCancelUrl) {
        addError(errors, 'cancel_url', PaymentError.CANCEL_URL_MISSING);
      }

      if (!hasTestMode) {
        addError(errors, 'test_mode', PaymentError.TEST_MODE_MISSING);
      } else if (!isValidTestMode) {
        addError(errors, 'test_mode', PaymentError.TEST_MODE_INVALID);
      }

      if (!hasLanguage) {
        addError(errors, 'language', PaymentError.LANGUAGE_MISSING);
      }

      if (!hasReqtype) {
        addError(errors, 'reqtype', PaymentError.REQTYPE_MISSING);
      } else if (!isValidReqtype) {
        addError(errors, 'reqtype', PaymentError.REQTYPE_INVALID);
      }

      if (!hasFurtherRnwInteraction) {
        addError(errors, 'further_rnw_interaction', PaymentError.FURTHER_RNW_INTERACTION_MISSING);
      } else if (!isValidFurtherRnwInteraction) {
        addError(errors, 'further_rnw_interaction', PaymentError.FURTHER_RNW_INTERACTION_INVALID);
      }

      return errors;
    }
  }, {
    key: "validateCreditCardIframe",
    value: function () {
      var _validateCreditCardIframe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payment, epik, creditCardIframe) {
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!creditCardIframe) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 3;
                return epik.validateCreditCardIframe(creditCardIframe);

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 4:
                return _context2.abrupt("return", {});

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee);
      }));

      function validateCreditCardIframe(_x, _x2, _x3) {
        return _validateCreditCardIframe.apply(this, arguments);
      }

      return validateCreditCardIframe;
    }()
  }, {
    key: "validatePaymentMethod",
    value: function validatePaymentMethod(payment) {
      var errors = {};
      var hasPaymentMethod = !!payment.payment_method;
      var isValidPaymentMethod = isSupportedPaymentMethod(payment.payment_method);

      if (!hasPaymentMethod) {
        addError(errors, 'payment_method', PaymentError.PAYMENT_METHOD_MISSING);
      } else if (!isValidPaymentMethod) {
        addError(errors, 'payment_method', PaymentError.PAYMENT_METHOD_INVALID);
      }

      return errors;
    }
  }, {
    key: "validatePaymentProvider",
    value: function validatePaymentProvider(payment) {
      var errors = {};
      var hasPaymentProvider = !!payment.payment_provider;
      var isValidPaymentProvider = isSupportedPaymentProvider(payment.payment_provider);

      if (hasPaymentProvider && !isValidPaymentProvider) {
        addError(errors, 'payment_provider', PaymentError.PAYMENT_PROVIDER_INVALID);
      }

      return errors;
    }
  }, {
    key: "validateRecurring",
    value: function validateRecurring(payment) {
      var errors = {};
      var isRecurring = !!payment.recurring;
      var isPseudoRecurring = !!payment.stored_pseudo_recurring;

      if (isRecurring || isPseudoRecurring) {
        var hasRecurringInterval = !!payment.recurring_interval;
        var hasEmail = !!payment.stored_customer_email;

        if (!hasRecurringInterval) {
          addError(errors, 'recurring_interval', PaymentError.RECURRING_INTERVAL_MISSING);
        }

        if (!hasEmail) {
          addError(errors, 'stored_customer_email', PaymentError.STORED_CUSTOMER_EMAIL_MISSING);
        }
      }

      return errors;
    }
  }, {
    key: "validateAmount",
    value: function validateAmount(payment) {
      var errors = {};
      var hasAmount = !!payment.amount;
      var isValidAmount = validateNumerical(payment.amount);

      if (!hasAmount) {
        addError(errors, 'amount', PaymentError.AMOUNT_MISSING);
      } else if (!isValidAmount) {
        addError(errors, 'amount', PaymentError.AMOUNT_INVALID);
      }

      return errors;
    }
  }, {
    key: "validateCurrency",
    value: function validateCurrency(payment) {
      var errors = {};
      var hasCurrency = !!payment.currency;

      if (!hasCurrency) {
        addError(errors, 'currency', PaymentError.CURRENCY_MISSING);
      }

      return errors;
    }
  }, {
    key: "validateCreditCard",
    value: function validateCreditCard(payment, epik, creditCardIframe) {
      var errors = {};

      if (isCreditCardPaymentMethod(payment.payment_method)) {
        var hasCardHolderName = !!payment.card_holder_name;

        if (!hasCardHolderName) {
          addError(errors, 'card_holder_name', PaymentError.CARD_HOLDER_NAME_MISSING);
        }

        if (!creditCardIframe) {
          var skipCvv = !!epik.config.skipCvv;
          var hasCardNumber = !!payment.cardno;
          var hasCvv = !!payment.cvv;
          var hasExpm = !!payment.expm;
          var hasExpy = !!payment.expy;
          var isValidCardNumber = validateCreditCardNumber(payment.cardno);
          var isValidCvv = validateCreditCardCvv(payment.cvv);
          var isValidExpm = validateCreditCardExpirationMonth(payment.expm);
          var isValidExpy = validateCreditCardExpirationYear(payment.expy);

          if (!hasCardNumber) {
            addError(errors, 'cardno', PaymentError.CARDNO_MISSING);
          } else if (!isValidCardNumber) {
            addError(errors, 'cardno', PaymentError.CARDNO_INVALID);
          }

          if (!skipCvv) {
            if (!hasCvv) {
              addError(errors, 'cvv', PaymentError.CVV_MISSING);
            } else if (!isValidCvv) {
              addError(errors, 'cvv', PaymentError.CVV_INVALID);
            }
          }

          if (!hasExpm) {
            addError(errors, 'expm', PaymentError.EXPM_MISSING);
          } else if (!isValidExpm) {
            addError(errors, 'expm', PaymentError.EXPM_INVALID);
          }

          if (!hasExpy) {
            addError(errors, 'expy', PaymentError.EXPY_MISSING);
          } else if (!isValidExpy) {
            addError(errors, 'expy', PaymentError.EXPY_INVALID);
          }
        }

        if (creditCardIframe) {
          var hasCardToken = !!payment.card_token;

          if (!hasCardToken) {
            addError(errors, 'card_token', PaymentError.CARD_TOKEN_MISSING);
          }
        }
      }

      return errors;
    }
  }, {
    key: "validateDirectDebit",
    value: function validateDirectDebit(payment) {
      var errors = {};

      if (payment.payment_method === PaymentMethod.DIRECT_DEBIT) {
        var hasIban = !!payment.iban;
        var isValidIban = validateIBAN(payment.iban);
        var hasBankbic = !!payment.bankbic;
        var hasBankName = !!payment.bank_name;
        var hasBankZipCode = !!payment.bank_zip_code;
        var hasBankCity = !!payment.bank_city;

        if (!hasIban) {
          addError(errors, 'iban', PaymentError.IBAN_MISSING);
        } else if (!isValidIban) {
          addError(errors, 'iban', PaymentError.IBAN_INVALID);
        }

        if (!hasBankbic) {
          addError(errors, 'bankbic', PaymentError.BANKBIC_MISSING);
        }

        if (!hasBankName) {
          addError(errors, 'bank_name', PaymentError.BANK_NAME_MISSING);
        }

        if (!hasBankZipCode) {
          addError(errors, 'bank_zip_code', PaymentError.BANK_ZIP_CODE_MISSING);
        }

        if (!hasBankCity) {
          addError(errors, 'bank_city', PaymentError.BANK_CITY_MISSING);
        }
      }

      return errors;
    }
  }, {
    key: "validateElv",
    value: function validateElv(payment) {
      var errors = {};

      if (payment.payment_method === PaymentMethod.ELEKTRONISCHES_LASTSCHRIFTVERFAHREN) {
        var hasBankiban = !!payment.bankiban;
        var isValidBankiban = validateIBAN(payment.bankiban);

        if (!hasBankiban) {
          addError(errors, 'bankiban', PaymentError.IBAN_MISSING);
        } else if (!isValidBankiban) {
          addError(errors, 'bankiban', PaymentError.IBAN_INVALID);
        }
      }

      return errors;
    }
  }, {
    key: "validateSepaOne",
    value: function validateSepaOne(payment) {
      var errors = {};

      if (payment.payment_method === PaymentMethod.SEPA_ONE) {
        var hasBankiban = !!payment.bankiban;
        var isValidBankiban = validateIBAN(payment.bankiban);
        var hasBankbic = !!payment.bankbic;

        if (!hasBankiban) {
          addError(errors, 'bankiban', PaymentError.IBAN_MISSING);
        } else if (!isValidBankiban) {
          addError(errors, 'bankiban', PaymentError.IBAN_INVALID);
        }

        if (!hasBankbic) {
          addError(errors, 'bankbic', PaymentError.BANKBIC_MISSING);
        }
      }

      return errors;
    }
  }, {
    key: "validatePaymentSlip",
    value: function validatePaymentSlip(payment, epik) {
      var _context3, _context4, _context5;

      var errors = {};
      var isEs = payment.payment_method === PaymentMethod.PAYMENT_SLIP;
      var isEzs = payment.payment_method === PaymentMethod.PAYMENT_SLIP_WITH_REFERENCE_NUMBER;
      var isChqr = payment.payment_method === PaymentMethod.SWISS_QR_BILL;
      var hasRefno = !!payment.refno;

      var hasEsOrdered = _includesInstanceProperty(_context3 = _keys(payment)).call(_context3, 'stored_es_ordered');

      var hasEzsOrdered = _includesInstanceProperty(_context4 = _keys(payment)).call(_context4, 'stored_ezs_ordered');

      var hasChqrOrdered = _includesInstanceProperty(_context5 = _keys(payment)).call(_context5, 'stored_chqr_ordered');

      if (isEs && !hasEsOrdered) {
        addError(errors, 'stored_es_ordered', PaymentError.STORED_ES_ORDERED_MISSING);
      }

      if (isEzs && !hasEzsOrdered) {
        addError(errors, 'stored_ezs_ordered', PaymentError.STORED_EZS_ORDERED_MISSING);
      }

      if (isChqr && !hasChqrOrdered) {
        addError(errors, 'stored_chqr_ordered', PaymentError.STORED_CHQR_ORDERED_MISSING);
      }

      if (isEzs && !hasRefno) {
        addError(errors, 'refno', PaymentError.REFNO_MISSING);
      }

      if (isChqr && !hasRefno && epik.config.requireSwissQrBillReferenceNumber) {
        addError(errors, 'refno', PaymentError.REFNO_MISSING);
      }

      return errors;
    }
  }, {
    key: "validateSms",
    value: function validateSms(payment) {
      var errors = {};

      if (payment.payment_method === PaymentMethod.SMS) {
        var hasMsisdn = !!payment.msisdn;
        var isValidMsisdn = validateMsisdn(payment.msisdn);

        if (!hasMsisdn) {
          addError(errors, 'msisdn', PaymentError.MSISDN_MISSING);
        } else if (!isValidMsisdn) {
          addError(errors, 'msisdn', PaymentError.MSISDN_INVALID);
        }
      }

      return errors;
    }
  }, {
    key: "validateCustomer",
    value: function validateCustomer(payment) {
      var errors = {};
      var paymentMethods = [PaymentMethod.DIRECT_DEBIT, PaymentMethod.PAYMENT_SLIP, PaymentMethod.PAYMENT_SLIP_WITH_REFERENCE_NUMBER, PaymentMethod.SWISS_QR_BILL];
      var validateCustomer = _includesInstanceProperty(paymentMethods).call(paymentMethods, payment.payment_method) || isCreditCardPaymentMethod(payment.payment_method);

      if (validateCustomer) {
        var hasFirstName = !!payment.stored_customer_firstname;
        var hasLastName = !!payment.stored_customer_lastname;

        if (!hasFirstName) {
          addError(errors, 'stored_customer_firstname', PaymentError.STORED_CUSTOMER_FIRSTNAME_MISSING);
        }

        if (!hasLastName) {
          addError(errors, 'stored_customer_lastname', PaymentError.STORED_CUSTOMER_LASTNAME_MISSING);
        }
      }

      return errors;
    }
  }, {
    key: "validateCustomerAddress",
    value: function validateCustomerAddress(payment) {
      var errors = {};
      var paymentMethods = [PaymentMethod.DIRECT_DEBIT, PaymentMethod.PAYMENT_SLIP, PaymentMethod.PAYMENT_SLIP_WITH_REFERENCE_NUMBER, PaymentMethod.SWISS_QR_BILL];
      var validateAddress = _includesInstanceProperty(paymentMethods).call(paymentMethods, payment.payment_method) || isCreditCardPaymentMethod(payment.payment_method);

      if (validateAddress) {
        var hasStreet = !!payment.stored_customer_street;
        var hasZipCode = !!payment.stored_customer_zip_code;
        var hasCity = !!payment.stored_customer_city;
        var hasCountry = !!payment.stored_customer_country;

        if (!hasStreet) {
          addError(errors, 'stored_customer_street', PaymentError.STORED_CUSTOMER_STREET_MISSING);
        }

        if (!hasZipCode) {
          addError(errors, 'stored_customer_zip_code', PaymentError.STORED_CUSTOMER_ZIP_CODE_MISSING);
        }

        if (!hasCity) {
          addError(errors, 'stored_customer_city', PaymentError.STORED_CUSTOMER_CITY_MISSING);
        }

        if (!hasCountry) {
          addError(errors, 'stored_customer_country', PaymentError.STORED_CUSTOMER_COUNTRY_MISSING);
        }
      }

      return errors;
    }
  }]);

  return PaymentValidator;
}(); ///////////////////////////////////////////////////////////////////////////////

var createPaymentValidator = function createPaymentValidator() {
  return new PaymentValidator();
};

///////////////////////////////////////////////////////////////////////////////
var PaymentStatusPoll = /*#__PURE__*/function () {
  function PaymentStatusPoll(args) {
    _classCallCheck(this, PaymentStatusPoll);

    var pollFn = args.pollFn,
        interval = args.interval;
    this.pollFn = pollFn;
    this.interval = interval;
  }

  _createClass(PaymentStatusPoll, [{
    key: "start",
    value: function start(paymentId) {
      if (!paymentId) {
        console.error('You must specify paymentId');
        return;
      }

      if (this.paymentId) {
        console.error('Payment status polling already started');
        return;
      }

      this.reset();
      this.paymentId = paymentId;
      this.counter = 0;
      this.poll();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.reset();
    }
  }, {
    key: "isRunning",
    value: function isRunning() {
      return !!this.paymentId && !!this.timerId;
    }
  }, {
    key: "reset",
    value: function reset() {
      clearTimeout(this.timerId);
      this.timerId = null;
      this.paymentId = null;
    }
  }, {
    key: "poll",
    value: function () {
      var _poll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.paymentId) {
                  _context.next = 3;
                  break;
                }

                this.reset();
                return _context.abrupt("return");

              case 3:
                this.counter++;
                _context.next = 6;
                return this.pollFn(this.paymentId);

              case 6:
                this.timerId = setTimeout(this.poll.bind(this), this.interval);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function poll() {
        return _poll.apply(this, arguments);
      }

      return poll;
    }()
  }]);

  return PaymentStatusPoll;
}(); ///////////////////////////////////////////////////////////////////////////////

var createPaymentStatusPoll = function createPaymentStatusPoll(args) {
  return new PaymentStatusPoll(args);
};

var HistoryMode;

(function (HistoryMode) {
  HistoryMode["BROWSER"] = "browser";
  HistoryMode["HASH"] = "hash";
})(HistoryMode || (HistoryMode = {}));

///////////////////////////////////////////////////////////////////////////////
var createRouter = function createRouter() {
  var historyMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : HistoryMode.BROWSER;

  var getHistoryMode = function getHistoryMode() {
    return historyMode;
  };

  var getLocation = function getLocation() {
    var url = null;

    if (historyMode === HistoryMode.BROWSER) {
      url = window.location.href;
    }

    if (historyMode === HistoryMode.HASH) {
      url = window.location.hash.replace(/^#/, '');
    }

    return getLocationFromUrl(url);
  };

  var getLocationFromUrl = function getLocationFromUrl(url) {
    if (url === '') {
      return {
        pathname: '/',
        search: '',
        hash: ''
      };
    }

    var a = document.createElement('a');
    a.href = url; // eslint-disable-next-line prefer-const

    var pathname = a.pathname,
        search = a.search,
        hash = a.hash; // ie11 doesn't have leading slash

    if (pathname[0] !== '/') {
      pathname = "/".concat(pathname);
    }

    return {
      pathname: pathname,
      search: search,
      hash: hash
    };
  };

  var buildFullUrlFromLocation = function buildFullUrlFromLocation(location) {
    var pathname = location.pathname,
        search = location.search,
        hash = location.hash;

    if (historyMode === HistoryMode.BROWSER) {
      return pathname + search + hash;
    }

    if (historyMode === HistoryMode.HASH) {
      var hashUrl = pathname + search + hash;
      var _window$location = window.location,
          wPathname = _window$location.pathname,
          wSearch = _window$location.search;
      return wPathname + wSearch + '#' + hashUrl;
    }
  };

  var push = function push(rawUrl) {
    var location = getLocationFromUrl(rawUrl);
    var url = buildFullUrlFromLocation(location);
    window.history.pushState(null, null, url);
  };

  var replace = function replace(rawUrl) {
    var location = getLocationFromUrl(rawUrl);
    var url = buildFullUrlFromLocation(location);
    window.history.replaceState(null, null, url);
  };

  var listen = function listen(locationChangeHandler) {
    var cb = function cb() {
      return locationChangeHandler(getLocation());
    };

    window.addEventListener('rnw.locationchange', cb);
    return function () {
      return window.removeEventListener('rnw.locationchange', cb);
    };
  };

  return {
    getHistoryMode: getHistoryMode,
    getLocation: getLocation,
    push: push,
    replace: replace,
    listen: listen
  };
};

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

///////////////////////////////////////////////////////////////////////////////
var Epik = /*#__PURE__*/function () {
  function Epik(args) {
    _classCallCheck(this, Epik);

    var config = args.config,
        win = args.win,
        validator = args.validator,
        preparator = args.preparator,
        cronHelper = args.cronHelper,
        epikEvents = args.epikEvents;
    this.config = config;
    this.window = win || window;
    this.eppProxy = createEppApiProxy({
      epik: this
    });
    this.epmsProxy = createEpmsApiProxy({
      epik: this
    });
    this.validator = validator || createPaymentValidator();
    this.preparator = preparator || createPaymentPreparator();
    this.cronHelper = cronHelper || createCronHelper();
    this.events = epikEvents || createEpikEvents();
    this.router = createRouter(HistoryMode.BROWSER);
    this.watchedQueryParams = {};
    this.initPaymentPolls();
    this.initLocationChangeHandling();
    this.initEventsHandling();
  }

  _createClass(Epik, [{
    key: "init",
    value: function init() {
      this.handleLocationChange();
    }
  }, {
    key: "initPaymentPolls",
    value: function initPaymentPolls() {
      var _this = this;

      this.eppPaymentStatusPoll = createPaymentStatusPoll({
        pollFn: function () {
          var _pollFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(paymentId) {
            var _yield$_this$fetchTra, paymentStatus, _error$response;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return _this.fetchTransaction(paymentId);

                  case 3:
                    _yield$_this$fetchTra = _context.sent;
                    paymentStatus = _yield$_this$fetchTra.epayment_status;
                    _context.next = 7;
                    return _this.events[EpikEventName.EPP_PAYMENT_STATUS_POLL].publish({
                      paymentId: paymentId,
                      paymentStatus: paymentStatus
                    });

                  case 7:
                    _context.next = 12;
                    break;

                  case 9:
                    _context.prev = 9;
                    _context.t0 = _context["catch"](0);

                    if (((_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 404) {
                      _this.eppPaymentStatusPoll.stop();
                    }

                  case 12:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[0, 9]]);
          }));

          function pollFn(_x) {
            return _pollFn.apply(this, arguments);
          }

          return pollFn;
        }(),
        interval: this.config.paymentStatusPollInterval
      });
      this.epmsPaymentStatusPoll = createPaymentStatusPoll({
        pollFn: function () {
          var _pollFn2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(paymentId) {
            var _yield$_this$fetchEpm, paymentStatus, _error$response2;

            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return _this.fetchEpmsPaymentStatus(paymentId);

                  case 3:
                    _yield$_this$fetchEpm = _context2.sent;
                    paymentStatus = _yield$_this$fetchEpm.status;
                    _context2.next = 7;
                    return _this.events[EpikEventName.EPMS_PAYMENT_STATUS_POLL].publish({
                      paymentId: paymentId,
                      paymentStatus: paymentStatus
                    });

                  case 7:
                    _context2.next = 12;
                    break;

                  case 9:
                    _context2.prev = 9;
                    _context2.t0 = _context2["catch"](0);

                    if (((_error$response2 = _context2.t0.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status) === 404) {
                      _this.epmsPaymentStatusPoll.stop();
                    }

                  case 12:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[0, 9]]);
          }));

          function pollFn(_x2) {
            return _pollFn2.apply(this, arguments);
          }

          return pollFn;
        }(),
        interval: this.config.paymentStatusPollInterval
      });
    }
  }, {
    key: "initLocationChangeHandling",
    value: function initLocationChangeHandling() {
      this.router.listen(this.handleLocationChange.bind(this));
    }
  }, {
    key: "handleLocationChange",
    value: function handleLocationChange() {
      var params = getLocationParams(this.router);

      var watchedQueryParams = _pick(params, WatchedEpikQueryParams);

      if (!_isEqual(watchedQueryParams, this.watchedQueryParams)) {
        this.watchedQueryParams = watchedQueryParams;
        this.fetchAndPublishPaymentData();
      }
    }
  }, {
    key: "initEventsHandling",
    value: function initEventsHandling() {
      var _this2 = this;

      var eventNames = [EpikEventName.FETCH_PAYMENT_DATA_START, EpikEventName.FETCH_PAYMENT_DATA_END, EpikEventName.SEND_EPP_PAYMENT_START, EpikEventName.SEND_EPMS_PAYMENT_START, EpikEventName.SEND_EPMS_PAYMENT_END, EpikEventName.SEND_EPMS_PAYMENT_ERROR, EpikEventName.UPDATE_EPMS_SUBSCRIPTION_START, EpikEventName.UPDATE_EPMS_SUBSCRIPTION_END, EpikEventName.UPDATE_EPMS_SUBSCRIPTION_ERROR, EpikEventName.EPP_PAYMENT_STATUS_POLL, EpikEventName.EPMS_PAYMENT_STATUS_POLL];

      _each(eventNames, function (eventName) {
        _this2.events[eventName].subscribe(function (event) {
          _this2.config.debug && console.debug('[epik]', event.eventName, event.data);
        });
      });

      this.events[EpikEventName.FETCH_PAYMENT_DATA_END].subscribe( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(event) {
          var _event$data$transacti, _event$data$transacti2, _event$data$epmsPayme, _event$data$epmsPayme2;

          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (event.data.transactionInfo) {
                    _this2.tryStartEppPaymentStatusPoll({
                      paymentId: (_event$data$transacti = event.data.transactionInfo) === null || _event$data$transacti === void 0 ? void 0 : _event$data$transacti.epp_transaction_id,
                      paymentStatus: (_event$data$transacti2 = event.data.transactionInfo) === null || _event$data$transacti2 === void 0 ? void 0 : _event$data$transacti2.epayment_status
                    });
                  }

                  if (event.data.epmsPaymentInfo) {
                    _this2.tryStartEpmsPaymentStatusPoll({
                      paymentId: (_event$data$epmsPayme = event.data.epmsPaymentInfo) === null || _event$data$epmsPayme === void 0 ? void 0 : _event$data$epmsPayme.uuid,
                      paymentStatus: (_event$data$epmsPayme2 = event.data.epmsPaymentInfo) === null || _event$data$epmsPayme2 === void 0 ? void 0 : _event$data$epmsPayme2.last_status
                    });
                  }

                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x3) {
          return _ref.apply(this, arguments);
        };
      }());
      this.events[EpikEventName.EPP_PAYMENT_STATUS_POLL].subscribe( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(event) {
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return _this2.tryStopEppPaymentStatusPoll(event.data.paymentStatus);

                case 2:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x4) {
          return _ref2.apply(this, arguments);
        };
      }());
      this.events[EpikEventName.EPMS_PAYMENT_STATUS_POLL].subscribe( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(event) {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return _this2.tryStopEpmsPaymentStatusPoll(event.data.paymentStatus);

                case 2:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x5) {
          return _ref3.apply(this, arguments);
        };
      }());
      this.events[EpikEventName.SEND_EPMS_PAYMENT_END].subscribe(function (event) {
        var epmsPaymentResponseData = event.data.epmsPaymentResponseData;

        if (epmsPaymentResponseData) {
          var _action_url;

          var action_type = _get(epmsPaymentResponseData, 'action.action_type');

          var action_url = _get(epmsPaymentResponseData, 'action.url');

          var payment_uuid = _get(epmsPaymentResponseData, 'objects.payment_uuid');

          var subscription_uuid = _get(epmsPaymentResponseData, 'objects.subscription_uuid');

          if (action_url) {
            // Analyse action URL to decide whether to directly open Twint app
            // (will be made easier with PAY-1376)
            var actionUrl = new _URL(action_url);
            var searchParams = actionUrl.searchParams;
            var pairingToken = searchParams.get('token');

            if (pairingToken) {
              var returnAppScheme = searchParams.get('returnAppScheme');
              var returnAppPackage = searchParams.get('returnAppPackage');

              if (returnAppScheme) {
                var _context6;

                action_url = _concatInstanceProperty(_context6 = "".concat(returnAppScheme, "://applinks/?al_applink_data=")).call(_context6, _JSON$stringify({
                  app_action_type: 'TWINT_PAYMENT',
                  extras: {
                    code: pairingToken
                  },
                  referer_app_link: {
                    app_name: 'SMALL_BUSINESS_SOLUTION'
                  },
                  version: '6.0'
                }));
              }

              if (returnAppPackage) {
                var _context7;

                action_url = _concatInstanceProperty(_context7 = "intent://payment#Intent;package=".concat(returnAppPackage, ";action=ch.twint.action.TWINT_PAYMENT;scheme=twint;S.code=")).call(_context7, pairingToken, ";S.startingOrigin=SMALL_BUSINESS_SOLUTION;end");
              }
            }
          }

          if ( // If we’re asked to redirect to a non-HTTP URL, Epik is
          // probably opening a payment app. When returning to the
          // browser, the user should see the payment’s status.
          action_type === 'redirect' && ((_action_url = action_url) === null || _action_url === void 0 ? void 0 : _action_url.substring(0, 4)) !== 'http' || // Also the case that we’re not required to take action by
          // the payment backend (usually because there was an error)
          // must be handled
          action_type === 'none') {
            var returnUrl = prepareReturnUrl(_this2.window.location.href);
            var params = {};

            if (payment_uuid || subscription_uuid) {
              params[EpikQueryParam.VIEW] = 'payment_result';
            }

            if (payment_uuid) {
              params[EpikQueryParam.EPMS_PAYMENT_UUID] = payment_uuid;
            }

            if (subscription_uuid) {
              params[EpikQueryParam.EPMS_SUBSCRIPTION_UUID] = subscription_uuid;
            } // Update query parameters without browser redirect (state is preserved).


            if (!_isEmpty(params)) {
              returnUrl = updateUrlParams(returnUrl, params);

              _this2.router.push(returnUrl);
            }
          } // Redirect to the checkout page


          if (action_type === 'redirect' && action_url) {
            window.location.href = action_url;
          }
        }
      });
      this.events[EpikEventName.UPDATE_EPMS_SUBSCRIPTION_END].subscribe(function (event) {
        var _ref4 = event.data || {},
            epmsSubscriptionUuid = _ref4.epmsSubscriptionUuid;

        var returnUrl = prepareReturnUrl(_this2.window.location.href);
        var params = {};

        if (epmsSubscriptionUuid) {
          params[EpikQueryParam.VIEW] = 'subscription_payment_method_update_result';
          params[EpikQueryParam.EPMS_SUBSCRIPTION_UUID] = epmsSubscriptionUuid;
        }

        if (!_isEmpty(params)) {
          returnUrl = updateUrlParams(returnUrl, params);

          _this2.router.push(returnUrl);
        }
      });
    } /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "updateCurrentUrl",
    value: function updateCurrentUrl(args) {
      var updatedUrl = getUpdatedUrl(this.router)(args);
      this.router.push(updatedUrl);
    } /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "fetchAndPublishPaymentData",
    value: function () {
      var _fetchAndPublishPaymentData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var params, eppTransactionId, subscriptionToken, lemaSubscriptionToken, customerToken, epmsPaymentUuid, epmsSubscriptionUuid, epmsPaymentSourceUuid, transactionInfo, subscriptionInfo, customerInfo, epmsPaymentInfo, epmsSubscriptionInfo, epmsPaymentSourceInfo, transactionError, subscriptionError, customerError, epmsPaymentError, epmsSubscriptionError, epmsPaymentSourceError, _transactionInfo, _subscriptionInfo, _epmsPaymentInfo;

        return _regeneratorRuntime.wrap(function _callee6$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.events[EpikEventName.FETCH_PAYMENT_DATA_START].publish();

              case 2:
                params = getLocationParams(this.router);
                eppTransactionId = params[EpikQueryParam.EPP_TRANSACTION_ID];
                subscriptionToken = params[EpikQueryParam.SUBSCRIPTION_TOKEN];
                lemaSubscriptionToken = params[EpikQueryParam.LEMA_SUBSCRIPTION_TOKEN];
                customerToken = params[EpikQueryParam.CUSTOMER_TOKEN];
                epmsPaymentUuid = params[EpikQueryParam.EPMS_PAYMENT_UUID];
                epmsSubscriptionUuid = params[EpikQueryParam.EPMS_SUBSCRIPTION_UUID];
                epmsPaymentSourceUuid = null;
                transactionInfo = null;
                subscriptionInfo = null;
                customerInfo = null;
                epmsPaymentInfo = null;
                epmsSubscriptionInfo = null;
                epmsPaymentSourceInfo = null;
                transactionError = null;
                subscriptionError = null;
                customerError = null;
                epmsPaymentError = null;
                epmsSubscriptionError = null;
                epmsPaymentSourceError = null; // epp

                if (!eppTransactionId) {
                  _context8.next = 34;
                  break;
                }

                _context8.prev = 23;
                _context8.next = 26;
                return this.fetchTransaction(eppTransactionId);

              case 26:
                transactionInfo = _context8.sent;

                if ((_transactionInfo = transactionInfo) !== null && _transactionInfo !== void 0 && _transactionInfo.subscription_token && !subscriptionToken) {
                  subscriptionToken = transactionInfo.subscription_token;
                }

                _context8.next = 34;
                break;

              case 30:
                _context8.prev = 30;
                _context8.t0 = _context8["catch"](23);
                console.log('fetch transaction error', _context8.t0);
                transactionError = {
                  code: 'NOT_FOUND'
                };

              case 34:
                if (!subscriptionToken) {
                  _context8.next = 46;
                  break;
                }

                _context8.prev = 35;
                _context8.next = 38;
                return this.fetchSubscription(subscriptionToken);

              case 38:
                subscriptionInfo = _context8.sent;

                if ((_subscriptionInfo = subscriptionInfo) !== null && _subscriptionInfo !== void 0 && _subscriptionInfo.customer_token && !customerToken) {
                  customerToken = subscriptionInfo.customer_token;
                }

                _context8.next = 46;
                break;

              case 42:
                _context8.prev = 42;
                _context8.t1 = _context8["catch"](35);
                console.log('fetch subscription error', _context8.t1);
                subscriptionError = {
                  code: 'NOT_FOUND'
                };

              case 46:
                if (!lemaSubscriptionToken) {
                  _context8.next = 57;
                  break;
                }

                _context8.prev = 47;
                _context8.next = 50;
                return this.fetchSubscription(lemaSubscriptionToken);

              case 50:
                subscriptionInfo = _context8.sent;
                _context8.next = 57;
                break;

              case 53:
                _context8.prev = 53;
                _context8.t2 = _context8["catch"](47);
                console.log('fetch subscription error', _context8.t2);
                subscriptionError = {
                  code: 'NOT_FOUND'
                };

              case 57:
                if (!customerToken) {
                  _context8.next = 68;
                  break;
                }

                _context8.prev = 58;
                _context8.next = 61;
                return this.fetchCustomer(customerToken);

              case 61:
                customerInfo = _context8.sent;
                _context8.next = 68;
                break;

              case 64:
                _context8.prev = 64;
                _context8.t3 = _context8["catch"](58);
                console.log('fetch customer error', _context8.t3);
                customerError = {
                  code: 'NOT_FOUND'
                };

              case 68:
                if (!epmsPaymentUuid) {
                  _context8.next = 80;
                  break;
                }

                _context8.prev = 69;
                _context8.next = 72;
                return this.fetchEpmsPayment(epmsPaymentUuid);

              case 72:
                epmsPaymentInfo = _context8.sent;

                if ((_epmsPaymentInfo = epmsPaymentInfo) !== null && _epmsPaymentInfo !== void 0 && _epmsPaymentInfo.created_subscription_uuid && !epmsSubscriptionUuid) {
                  epmsSubscriptionUuid = epmsPaymentInfo.created_subscription_uuid;
                }

                _context8.next = 80;
                break;

              case 76:
                _context8.prev = 76;
                _context8.t4 = _context8["catch"](69);
                console.log('fetch epms payment error', _context8.t4);
                epmsPaymentError = {
                  code: 'NOT_FOUND'
                };

              case 80:
                if (!epmsSubscriptionUuid) {
                  _context8.next = 92;
                  break;
                }

                _context8.prev = 81;
                _context8.next = 84;
                return this.fetchEpmsSubscription(epmsSubscriptionUuid);

              case 84:
                epmsSubscriptionInfo = _context8.sent;

                if (epmsSubscriptionInfo) {
                  epmsPaymentSourceUuid = epmsSubscriptionInfo.payment_source_uuid;
                }

                _context8.next = 92;
                break;

              case 88:
                _context8.prev = 88;
                _context8.t5 = _context8["catch"](81);
                console.log('fetch epms subscription error', _context8.t5);
                epmsSubscriptionError = {
                  code: 'NOT_FOUND'
                };

              case 92:
                if (!(epmsSubscriptionInfo && !epmsPaymentInfo)) {
                  _context8.next = 104;
                  break;
                }

                _context8.prev = 93;
                _context8.next = 96;
                return this.fetchEpmsPaymentBySubscriptionUuid(epmsSubscriptionInfo.uuid);

              case 96:
                epmsPaymentInfo = _context8.sent;
                epmsPaymentError = null;
                _context8.next = 104;
                break;

              case 100:
                _context8.prev = 100;
                _context8.t6 = _context8["catch"](93);
                console.log('fetch epms payment error', _context8.t6);
                epmsPaymentError = {
                  code: 'NOT_FOUND'
                };

              case 104:
                if (!epmsPaymentSourceUuid) {
                  _context8.next = 115;
                  break;
                }

                _context8.prev = 105;
                _context8.next = 108;
                return this.fetchEpmsPaymentSource(epmsPaymentSourceUuid);

              case 108:
                epmsPaymentSourceInfo = _context8.sent;
                _context8.next = 115;
                break;

              case 111:
                _context8.prev = 111;
                _context8.t7 = _context8["catch"](105);
                console.log('fetch epms payment source error', _context8.t7);
                epmsPaymentSourceError = {
                  code: 'NOT_FOUND'
                };

              case 115:
                _context8.next = 117;
                return this.events[EpikEventName.FETCH_PAYMENT_DATA_END].publish({
                  transactionInfo: transactionInfo,
                  subscriptionInfo: subscriptionInfo,
                  customerInfo: customerInfo,
                  epmsPaymentInfo: epmsPaymentInfo,
                  epmsSubscriptionInfo: epmsSubscriptionInfo,
                  epmsPaymentSourceInfo: epmsPaymentSourceInfo,
                  transactionError: transactionError,
                  subscriptionError: subscriptionError,
                  customerError: customerError,
                  epmsPaymentError: epmsPaymentError,
                  epmsSubscriptionError: epmsSubscriptionError,
                  epmsPaymentSourceError: epmsPaymentSourceError
                });

              case 117:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee6, this, [[23, 30], [35, 42], [47, 53], [58, 64], [69, 76], [81, 88], [93, 100], [105, 111]]);
      }));

      function fetchAndPublishPaymentData() {
        return _fetchAndPublishPaymentData.apply(this, arguments);
      }

      return fetchAndPublishPaymentData;
    }() /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "createPayment",
    value: function createPayment$1(payment) {
      return createPayment(this, payment);
    }
  }, {
    key: "getCreditCardToken",
    value: function () {
      var _getCreditCardToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(args) {
        var _this$config, eppApiUrl, eppApiKey, epmsApiUrl, epmsAccountUuid, skipCvv, flow, cardno, expm, expy, cvv, payloadData, _yield$axios$request, data, _payloadData, _yield$axios$request2, _data;

        return _regeneratorRuntime.wrap(function _callee7$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this$config = this.config, eppApiUrl = _this$config.eppApiUrl, eppApiKey = _this$config.eppApiKey, epmsApiUrl = _this$config.epmsApiUrl, epmsAccountUuid = _this$config.epmsAccountUuid, skipCvv = _this$config.skipCvv; // eslint-disable-next-line prefer-const

                flow = args.flow, cardno = args.cardno, expm = args.expm, expy = args.expy, cvv = args.cvv;
                expy = prepareExpirationYear(expy, flow);

                if (!(flow == PaymentFlow.EPP)) {
                  _context9.next = 13;
                  break;
                }

                payloadData = {
                  cardno: cardno,
                  expm: expm,
                  expy: expy,
                  merchant_config_identifier: eppApiKey
                };

                if (!skipCvv) {
                  payloadData['cvv'] = cvv;
                }

                _context9.next = 8;
                return axios.request({
                  url: eppApiUrl + '/api/v1/card/token',
                  method: 'post',
                  data: payloadData
                });

              case 8:
                _yield$axios$request = _context9.sent;
                data = _yield$axios$request.data;
                return _context9.abrupt("return", data.token);

              case 13:
                if (!(flow === PaymentFlow.EPMS)) {
                  _context9.next = 21;
                  break;
                }

                _payloadData = {
                  payment_information: {
                    number: cardno,
                    expiry_month: expm,
                    expiry_year: expy
                  },
                  account_uuid: epmsAccountUuid
                };

                if (!skipCvv) {
                  _payloadData['payment_information']['cvv'] = cvv;
                }

                _context9.next = 18;
                return axios.request({
                  url: epmsApiUrl + '/payment-tokens',
                  method: 'post',
                  data: _payloadData
                });

              case 18:
                _yield$axios$request2 = _context9.sent;
                _data = _yield$axios$request2.data;
                return _context9.abrupt("return", _data.token);

              case 21:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee7, this);
      }));

      function getCreditCardToken(_x6) {
        return _getCreditCardToken.apply(this, arguments);
      }

      return getCreditCardToken;
    }()
  }, {
    key: "createCreditCardIframe",
    value: function () {
      var _createCreditCardIframe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(targetSelector, url, flow) {
        var _this3 = this;

        var debug, channel, iframeUrl, options, iframe, messenger, setCreditCardIframeHeight;
        return _regeneratorRuntime.wrap(function _callee8$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                debug = this.config.debug;
                channel = 'rnw.epik.' + Date.now().toString();
                iframeUrl = updateUrlParams(url, {
                  channel: channel,
                  debug: debug,
                  flow: flow
                });
                options = {
                  name: 'credit-card-iframe'
                };
                _context10.next = 6;
                return createAndInjectIframe(this.window.document, options, targetSelector);

              case 6:
                iframe = _context10.sent;
                messenger = new Messenger({
                  listenTo: window,
                  emitTo: iframe.contentWindow,
                  label: 'main',
                  channel: channel,
                  debug: debug
                });

                setCreditCardIframeHeight = function setCreditCardIframeHeight(height) {
                  return iframe.style.height = "".concat(height, "px");
                };

                messenger.on(CreditCardIframeMessageType.HEIGHT, function (height) {
                  return setCreditCardIframeHeight(height);
                });
                messenger.respond(CreditCardIframeMessageType.EPIK_CONFIG, function () {
                  return _this3.config;
                }); // set iframe src after messenger subscriptions

                iframe.src = iframeUrl;
                return _context10.abrupt("return", {
                  iframe: iframe,
                  messenger: messenger
                });

              case 13:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee8, this);
      }));

      function createCreditCardIframe(_x7, _x8, _x9) {
        return _createCreditCardIframe.apply(this, arguments);
      }

      return createCreditCardIframe;
    }()
  }, {
    key: "validateCreditCardIframe",
    value: function () {
      var _validateCreditCardIframe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(creditCardIframe) {
        return _regeneratorRuntime.wrap(function _callee9$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", creditCardIframe.messenger.request(CreditCardIframeMessageType.VALIDATE));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee9);
      }));

      function validateCreditCardIframe(_x10) {
        return _validateCreditCardIframe.apply(this, arguments);
      }

      return validateCreditCardIframe;
    }()
  }, {
    key: "acquireCreditCardTokenFromIframe",
    value: function () {
      var _acquireCreditCardTokenFromIframe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(creditCardIframe) {
        return _regeneratorRuntime.wrap(function _callee10$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", creditCardIframe.messenger.request(CreditCardIframeMessageType.TOKENIZE));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee10);
      }));

      function acquireCreditCardTokenFromIframe(_x11) {
        return _acquireCreditCardTokenFromIframe.apply(this, arguments);
      }

      return acquireCreditCardTokenFromIframe;
    }()
  }, {
    key: "acquireCreditCardTypeFromIframe",
    value: function () {
      var _acquireCreditCardTypeFromIframe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(creditCardIframe) {
        return _regeneratorRuntime.wrap(function _callee11$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", creditCardIframe.messenger.request(CreditCardIframeMessageType.DETECT_CREDIT_CARD_TYPE));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee11);
      }));

      function acquireCreditCardTypeFromIframe(_x12) {
        return _acquireCreditCardTypeFromIframe.apply(this, arguments);
      }

      return acquireCreditCardTypeFromIframe;
    }() /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "sendPayment",
    value: function () {
      var _sendPayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(payment, creditCardIframe) {
        var paymentFlow;
        return _regeneratorRuntime.wrap(function _callee12$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.preparePayment(payment, creditCardIframe);

              case 2:
                payment = _context14.sent;
                cleanBlankFields(payment);
                paymentFlow = this.getPaymentFlow(payment);
                _context14.next = 7;
                return paymentFlow.start(this, payment, this.window);

              case 7:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee12, this);
      }));

      function sendPayment(_x13, _x14) {
        return _sendPayment.apply(this, arguments);
      }

      return sendPayment;
    }() /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "validatePayment",
    value: function () {
      var _validatePayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(payment, creditCardIframe) {
        var errors;
        return _regeneratorRuntime.wrap(function _callee13$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.preparePayment(payment, creditCardIframe);

              case 2:
                payment = _context15.sent;
                _context15.t0 = _objectSpread;
                _context15.t1 = _objectSpread;
                _context15.t2 = _objectSpread;
                _context15.t3 = _objectSpread;
                _context15.t4 = _objectSpread;
                _context15.t5 = _objectSpread;
                _context15.t6 = _objectSpread;
                _context15.t7 = _objectSpread;
                _context15.t8 = _objectSpread;
                _context15.t9 = _objectSpread;
                _context15.t10 = _objectSpread;
                _context15.t11 = _objectSpread;
                _context15.t12 = _objectSpread;
                _context15.t13 = _objectSpread;
                _context15.t14 = _objectSpread({}, this.validator.validateMetadata(payment));
                _context15.next = 20;
                return this.validator.validateCreditCardIframe(payment, this, creditCardIframe);

              case 20:
                _context15.t15 = _context15.sent;
                _context15.t16 = (0, _context15.t13)(_context15.t14, _context15.t15);
                _context15.t17 = this.validator.validatePaymentMethod(payment);
                _context15.t18 = (0, _context15.t12)(_context15.t16, _context15.t17);
                _context15.t19 = this.validator.validatePaymentProvider(payment);
                _context15.t20 = (0, _context15.t11)(_context15.t18, _context15.t19);
                _context15.t21 = this.validator.validateRecurring(payment);
                _context15.t22 = (0, _context15.t10)(_context15.t20, _context15.t21);
                _context15.t23 = this.validator.validateAmount(payment);
                _context15.t24 = (0, _context15.t9)(_context15.t22, _context15.t23);
                _context15.t25 = this.validator.validateCurrency(payment);
                _context15.t26 = (0, _context15.t8)(_context15.t24, _context15.t25);
                _context15.t27 = this.validator.validateCreditCard(payment, this, creditCardIframe);
                _context15.t28 = (0, _context15.t7)(_context15.t26, _context15.t27);
                _context15.t29 = this.validator.validateDirectDebit(payment);
                _context15.t30 = (0, _context15.t6)(_context15.t28, _context15.t29);
                _context15.t31 = this.validator.validateElv(payment);
                _context15.t32 = (0, _context15.t5)(_context15.t30, _context15.t31);
                _context15.t33 = this.validator.validateSepaOne(payment);
                _context15.t34 = (0, _context15.t4)(_context15.t32, _context15.t33);
                _context15.t35 = this.validator.validatePaymentSlip(payment, this);
                _context15.t36 = (0, _context15.t3)(_context15.t34, _context15.t35);
                _context15.t37 = this.validator.validateSms(payment);
                _context15.t38 = (0, _context15.t2)(_context15.t36, _context15.t37);
                _context15.t39 = this.validator.validateCustomer(payment);
                _context15.t40 = (0, _context15.t1)(_context15.t38, _context15.t39);
                _context15.t41 = this.validator.validateCustomerAddress(payment);
                errors = (0, _context15.t0)(_context15.t40, _context15.t41);
                return _context15.abrupt("return", _keys(errors).length > 0 ? errors : null);

              case 49:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee13, this);
      }));

      function validatePayment(_x15, _x16) {
        return _validatePayment.apply(this, arguments);
      }

      return validatePayment;
    }()
  }, {
    key: "preparePayment",
    value: function () {
      var _preparePayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(payment, creditCardIframe) {
        var _context16;

        var relevantFields;
        return _regeneratorRuntime.wrap(function _callee14$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                payment = _cloneDeep(payment);
                _context17.t0 = _concatInstanceProperty(_context16 = []);
                _context17.t1 = _context16;
                _context17.t2 = _toConsumableArray(this.preparator.prepareMetadata(payment, this));
                _context17.t3 = _toConsumableArray(this.preparator.prepareHmac(payment));
                _context17.t4 = _toConsumableArray(this.preparator.prepareRecurring(payment, this));
                _context17.t5 = _toConsumableArray;
                _context17.next = 9;
                return this.preparator.prepareCreditCard(payment, this, creditCardIframe);

              case 9:
                _context17.t6 = _context17.sent;
                _context17.t7 = (0, _context17.t5)(_context17.t6);
                _context17.t8 = _toConsumableArray(this.preparator.prepareDirectDebit(payment));
                _context17.t9 = _toConsumableArray(this.preparator.prepareElv(payment));
                _context17.t10 = _toConsumableArray(this.preparator.prepareSepaOne(payment));
                _context17.t11 = _toConsumableArray;
                _context17.next = 17;
                return this.preparator.preparePaymentSlip(payment, this);

              case 17:
                _context17.t12 = _context17.sent;
                _context17.t13 = (0, _context17.t11)(_context17.t12);
                _context17.t14 = _toConsumableArray(this.preparator.prepareSms(payment));
                _context17.t15 = _toConsumableArray(this.preparator.prepareCustomFields(payment));
                relevantFields = _context17.t0.call.call(_context17.t0, _context17.t1, _context17.t2, _context17.t3, _context17.t4, _context17.t7, _context17.t8, _context17.t9, _context17.t10, _context17.t13, _context17.t14, _context17.t15);
                return _context17.abrupt("return", _pick(payment, relevantFields));

              case 23:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee14, this);
      }));

      function preparePayment(_x17, _x18) {
        return _preparePayment.apply(this, arguments);
      }

      return preparePayment;
    }() /////////////////////////////////////////////////////////////////////////////
    // epp
    /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "fetchTransaction",
    value: function () {
      var _fetchTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(eppTransactionId) {
        var eppApiKey, data;
        return _regeneratorRuntime.wrap(function _callee15$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                eppApiKey = this.config.eppApiKey;
                _context18.next = 3;
                return this.eppProxy.fetchTransaction({
                  eppApiKey: eppApiKey,
                  eppTransactionId: eppTransactionId
                });

              case 3:
                data = _context18.sent;
                data = this.prepareTransactionInfo(data);
                return _context18.abrupt("return", data);

              case 6:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee15, this);
      }));

      function fetchTransaction(_x19) {
        return _fetchTransaction.apply(this, arguments);
      }

      return fetchTransaction;
    }()
  }, {
    key: "fetchSubscription",
    value: function () {
      var _fetchSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(subscriptionToken) {
        var eppApiKey, data;
        return _regeneratorRuntime.wrap(function _callee16$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                eppApiKey = this.config.eppApiKey;
                _context19.next = 3;
                return this.eppProxy.fetchSubscription({
                  eppApiKey: eppApiKey,
                  subscriptionToken: subscriptionToken
                });

              case 3:
                data = _context19.sent;
                data.subscription_token = subscriptionToken;
                data = this.prepareSubscriptionInfo(data);
                return _context19.abrupt("return", data);

              case 7:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee16, this);
      }));

      function fetchSubscription(_x20) {
        return _fetchSubscription.apply(this, arguments);
      }

      return fetchSubscription;
    }()
  }, {
    key: "cancelSubscription",
    value: function () {
      var _cancelSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(subscriptionToken) {
        var eppApiKey;
        return _regeneratorRuntime.wrap(function _callee17$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                eppApiKey = this.config.eppApiKey;
                _context20.next = 3;
                return this.eppProxy.cancelSubscription({
                  eppApiKey: eppApiKey,
                  subscriptionToken: subscriptionToken
                });

              case 3:
                return _context20.abrupt("return", this.fetchSubscription(subscriptionToken));

              case 4:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee17, this);
      }));

      function cancelSubscription(_x21) {
        return _cancelSubscription.apply(this, arguments);
      }

      return cancelSubscription;
    }()
  }, {
    key: "fetchCustomer",
    value: function () {
      var _fetchCustomer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(customerToken) {
        var eppApiKey;
        return _regeneratorRuntime.wrap(function _callee18$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                eppApiKey = this.config.eppApiKey;
                return _context21.abrupt("return", this.eppProxy.fetchCustomer({
                  eppApiKey: eppApiKey,
                  customerToken: customerToken
                }));

              case 2:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee18, this);
      }));

      function fetchCustomer(_x22) {
        return _fetchCustomer.apply(this, arguments);
      }

      return fetchCustomer;
    }()
  }, {
    key: "updateCustomer",
    value: function () {
      var _updateCustomer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(customerToken, fields) {
        var eppApiKey;
        return _regeneratorRuntime.wrap(function _callee19$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                eppApiKey = this.config.eppApiKey;
                _context22.next = 3;
                return this.eppProxy.updateCustomer({
                  eppApiKey: eppApiKey,
                  customerToken: customerToken,
                  fields: fields
                });

              case 3:
                return _context22.abrupt("return", this.fetchCustomer(customerToken));

              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee19, this);
      }));

      function updateCustomer(_x23, _x24) {
        return _updateCustomer.apply(this, arguments);
      }

      return updateCustomer;
    }()
  }, {
    key: "fetchReferenceNumber",
    value: function () {
      var _fetchReferenceNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(campaignId) {
        var _this4 = this;

        var _this$config2, eppApiKey, eppMerchantId, refno;

        return _regeneratorRuntime.wrap(function _callee21$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                this.config.debug && console.debug('[epik] fetching refno');
                _this$config2 = this.config, eppApiKey = _this$config2.eppApiKey, eppMerchantId = _this$config2.eppMerchantId;
                _context24.prev = 2;
                _context24.next = 5;
                return pRetry( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
                  var _error$response3;

                  return _regeneratorRuntime.wrap(function _callee20$(_context23) {
                    while (1) {
                      switch (_context23.prev = _context23.next) {
                        case 0:
                          _context23.prev = 0;
                          _context23.next = 3;
                          return _this4.eppProxy.fetchReferenceNumber({
                            eppApiKey: eppApiKey,
                            eppMerchantId: eppMerchantId,
                            campaignId: campaignId
                          });

                        case 3:
                          refno = _context23.sent;
                          _context23.next = 10;
                          break;

                        case 6:
                          _context23.prev = 6;
                          _context23.t0 = _context23["catch"](0);

                          if (!(((_error$response3 = _context23.t0.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.status) === 408)) {
                            _context23.next = 10;
                            break;
                          }

                          throw _context23.t0;

                        case 10:
                        case "end":
                          return _context23.stop();
                      }
                    }
                  }, _callee20, null, [[0, 6]]);
                })), {
                  retries: 5,
                  factor: 1,
                  minTimeout: 0,
                  onFailedAttempt: function onFailedAttempt(error) {
                    _this4.config.debug && console.log("[epik] fetching refno attempt ".concat(error.attemptNumber, " failed"));
                  }
                });

              case 5:
                _context24.next = 9;
                break;

              case 7:
                _context24.prev = 7;
                _context24.t0 = _context24["catch"](2);

              case 9:
                return _context24.abrupt("return", refno);

              case 10:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee21, this, [[2, 7]]);
      }));

      function fetchReferenceNumber(_x25) {
        return _fetchReferenceNumber.apply(this, arguments);
      }

      return fetchReferenceNumber;
    }() /////////////////////////////////////////////////////////////////////////////
    // epms
    /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "fetchEpmsPayment",
    value: function () {
      var _fetchEpmsPayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(epmsPaymentUuid) {
        return _regeneratorRuntime.wrap(function _callee22$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                return _context25.abrupt("return", this.epmsProxy.fetchPayment({
                  epmsPaymentUuid: epmsPaymentUuid
                }));

              case 1:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee22, this);
      }));

      function fetchEpmsPayment(_x26) {
        return _fetchEpmsPayment.apply(this, arguments);
      }

      return fetchEpmsPayment;
    }()
  }, {
    key: "fetchEpmsPaymentStatus",
    value: function () {
      var _fetchEpmsPaymentStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(epmsPaymentUuid) {
        return _regeneratorRuntime.wrap(function _callee23$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                return _context26.abrupt("return", this.epmsProxy.fetchPaymentStatus({
                  epmsPaymentUuid: epmsPaymentUuid
                }));

              case 1:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee23, this);
      }));

      function fetchEpmsPaymentStatus(_x27) {
        return _fetchEpmsPaymentStatus.apply(this, arguments);
      }

      return fetchEpmsPaymentStatus;
    }()
  }, {
    key: "fetchEpmsSubscription",
    value: function () {
      var _fetchEpmsSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(epmsSubscriptionUuid) {
        return _regeneratorRuntime.wrap(function _callee24$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                return _context27.abrupt("return", this.epmsProxy.fetchSubscription({
                  epmsSubscriptionUuid: epmsSubscriptionUuid
                }));

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee24, this);
      }));

      function fetchEpmsSubscription(_x28) {
        return _fetchEpmsSubscription.apply(this, arguments);
      }

      return fetchEpmsSubscription;
    }()
  }, {
    key: "fetchEpmsPaymentSource",
    value: function () {
      var _fetchEpmsPaymentSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(epmsPaymentSourceUuid) {
        return _regeneratorRuntime.wrap(function _callee25$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                return _context28.abrupt("return", this.epmsProxy.fetchPaymentSource({
                  epmsPaymentSourceUuid: epmsPaymentSourceUuid
                }));

              case 1:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee25, this);
      }));

      function fetchEpmsPaymentSource(_x29) {
        return _fetchEpmsPaymentSource.apply(this, arguments);
      }

      return fetchEpmsPaymentSource;
    }()
  }, {
    key: "fetchEpmsPaymentBySubscriptionUuid",
    value: function () {
      var _fetchEpmsPaymentBySubscriptionUuid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(epmsSubscriptionUuid) {
        return _regeneratorRuntime.wrap(function _callee26$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                return _context29.abrupt("return", this.epmsProxy.fetchPaymentBySubscriptionUuid({
                  epmsSubscriptionUuid: epmsSubscriptionUuid
                }));

              case 1:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee26, this);
      }));

      function fetchEpmsPaymentBySubscriptionUuid(_x30) {
        return _fetchEpmsPaymentBySubscriptionUuid.apply(this, arguments);
      }

      return fetchEpmsPaymentBySubscriptionUuid;
    }()
  }, {
    key: "cancelEpmsPayment",
    value: function () {
      var _cancelEpmsPayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(epmsPaymentUuid) {
        return _regeneratorRuntime.wrap(function _callee27$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                return _context30.abrupt("return", this.epmsProxy.cancelPayment({
                  epmsPaymentUuid: epmsPaymentUuid
                }));

              case 1:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee27, this);
      }));

      function cancelEpmsPayment(_x31) {
        return _cancelEpmsPayment.apply(this, arguments);
      }

      return cancelEpmsPayment;
    }()
  }, {
    key: "cancelEpmsSubscription",
    value: function () {
      var _cancelEpmsSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(epmsSubscriptionUuid) {
        return _regeneratorRuntime.wrap(function _callee28$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                return _context31.abrupt("return", this.epmsProxy.cancelSubscription({
                  epmsSubscriptionUuid: epmsSubscriptionUuid
                }));

              case 1:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee28, this);
      }));

      function cancelEpmsSubscription(_x32) {
        return _cancelEpmsSubscription.apply(this, arguments);
      }

      return cancelEpmsSubscription;
    }() /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "getPaymentFlow",
    value: function getPaymentFlow(payment) {
      var paymentFlow = null;
      var supportedPaymentFlows = getSupportedPaymentFlows(payment.payment_method);

      if (payment.flow && _includesInstanceProperty(supportedPaymentFlows).call(supportedPaymentFlows, payment.flow)) {
        paymentFlow = payment.flow;
      } else {
        paymentFlow = supportedPaymentFlows[0];
      }

      delete payment.flow;
      return createPaymentFlow(paymentFlow);
    } /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "prepareTransactionInfo",
    value: function prepareTransactionInfo(data) {
      data = this.normalizedCurrency(data);
      data = this.normalizedPaymentMethod(data);
      data = this.normalizedFinalStatus(data);
      return data;
    }
  }, {
    key: "prepareSubscriptionInfo",
    value: function prepareSubscriptionInfo(data) {
      data = this.normalizedCurrency(data);
      data = this.normalizedPaymentMethod(data);
      data = this.normalizeRecurringInterval(data);
      return data;
    } /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "normalizedCurrency",
    value: function normalizedCurrency(data) {
      data = _cloneDeep(data);
      data.currency = (data.currency || '').toLowerCase();
      return data;
    }
  }, {
    key: "normalizedPaymentMethod",
    value: function normalizedPaymentMethod(data) {
      data = _cloneDeep(data);
      data.payment_method = (data.payment_method || '').toLowerCase();
      return data;
    }
  }, {
    key: "normalizeRecurringInterval",
    value: function normalizeRecurringInterval(data) {
      data = _cloneDeep(data);

      if (!data.stored_rnw_recurring_interval_name) {
        var recurring_interval = this.cronHelper.getRecurringIntervalName(data.interval);
        data.stored_rnw_recurring_interval_name = (recurring_interval || '').toLowerCase();
      }

      return data;
    }
  }, {
    key: "normalizedFinalStatus",
    value: function normalizedFinalStatus(data) {
      data = _cloneDeep(data);
      var finalStatusesMap = {
        success: TransactionStatus.SUCCESS,
        aborted_by_user: TransactionStatus.CANCEL,
        final_success: TransactionStatus.SUCCESS,
        error_from_paymentprovider: TransactionStatus.ERROR,
        final_error: TransactionStatus.ERROR,
        final_cancel: TransactionStatus.CANCEL,
        authorization_success: TransactionStatus.SUCCESS,
        success_from_payment_provider: TransactionStatus.SUCCESS,
        timeout: TransactionStatus.CANCEL
      };

      if (_isArray(data.status)) {
        var statusesCount = data.status.length;
        var finalStatus = (data.status[statusesCount - 1] || {}).statusName;
        var previousStatus = (data.status[statusesCount - 2] || {}).statusName;

        if (isPaymentMethodWithDeferredStatus(data.payment_method)) {
          // for sms payment in test_mode – we force polling to run at least transactionStatusPollForceRequestsCount times
          var isSmsPaymentMethod = data.payment_method === PaymentMethod.SMS;
          var isCounterFinished = this.eppPaymentStatusPoll.counter >= this.config.paymentStatusPollForceRequestsCount;
          var isPollForced = data.test_mode && isSmsPaymentMethod && !isCounterFinished;

          if (isPollForced) {
            data.epayment_status = TransactionStatus.PENDING;
          } else {
            // default epayment_status is "pending"
            data.epayment_status = TransactionStatus.PENDING;

            if (finalStatus === 'final_error' || finalStatus === 'aborted_by_user' || finalStatus === 'final_cancel') {
              data.epayment_status = TransactionStatus.CANCEL;
            }

            if (finalStatus === 'final_success') {
              data.epayment_status = TransactionStatus.SUCCESS;
            }
          }
        } else {
          var isSodPaymentMethod = data.payment_method === PaymentMethod.SEPA_ONE;
          var isRecurring = !!data.recurring_interval && !!data.subscription_token; // determine status from mapping

          data.epayment_status = finalStatusesMap[finalStatus] || TransactionStatus.ERROR; // handle special cases

          if (finalStatus === 'final_cancel' && previousStatus === 'authorization_success') {
            data.epayment_status = TransactionStatus.SUCCESS;
          }

          if (isSodPaymentMethod && isRecurring && finalStatus === 'final_cancel' && previousStatus === 'success') {
            data.epayment_status = TransactionStatus.SUCCESS;
          }
        }
      } else {
        data.epayment_status = TransactionStatus.ERROR;
      }

      return data;
    } /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "tryStartEppPaymentStatusPoll",
    value: function tryStartEppPaymentStatusPoll(args) {
      var paymentId = args.paymentId,
          paymentStatus = args.paymentStatus;
      var isPending = paymentStatus === TransactionStatus.PENDING;
      var isPaymentStatusPollRunning = this.eppPaymentStatusPoll.isRunning();

      if (paymentId && isPending && !isPaymentStatusPollRunning) {
        this.eppPaymentStatusPoll.start(paymentId);
      }
    }
  }, {
    key: "tryStopEppPaymentStatusPoll",
    value: function tryStopEppPaymentStatusPoll(paymentStatus) {
      var isPending = paymentStatus === TransactionStatus.PENDING;
      var isPaymentStatusPollRunning = this.eppPaymentStatusPoll.isRunning();

      if (!isPending && isPaymentStatusPollRunning) {
        this.eppPaymentStatusPoll.stop();
      }
    } /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "tryStartEpmsPaymentStatusPoll",
    value: function tryStartEpmsPaymentStatusPoll(args) {
      var paymentId = args.paymentId,
          paymentStatus = args.paymentStatus;
      var isPending = paymentStatus === EpmsPaymentStatus.PENDING;
      var isPaymentStatusPollRunning = this.epmsPaymentStatusPoll.isRunning();

      if (paymentId && isPending && !isPaymentStatusPollRunning) {
        this.epmsPaymentStatusPoll.start(paymentId);
      }
    }
  }, {
    key: "tryStopEpmsPaymentStatusPoll",
    value: function tryStopEpmsPaymentStatusPoll(paymentStatus) {
      var isPending = paymentStatus === EpmsPaymentStatus.PENDING;
      var isPaymentStatusPollRunning = this.epmsPaymentStatusPoll.isRunning();

      if (!isPending && isPaymentStatusPollRunning) {
        this.epmsPaymentStatusPoll.stop();
      }
    }
  }]);

  return Epik;
}(); ///////////////////////////////////////////////////////////////////////////////

var createEpik = function createEpik() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  config = createEpikConfig(config);
  return new Epik({
    config: config
  });
};

export { AllEpikQueryParams, CreditCardIframeMessageType, CreditCardPaymentMethods, CronHelper, Epik, EpikEventName, EpikEventer, EpikQueryParam, EpmsApiProxy, EpmsPaymentStatus, EpmsPaymentStatusReason, EpmsSubscriptionStatus, EppApiProxy, Messenger, OneTimePaymentMethods, Payment, PaymentCurrency, PaymentError, PaymentFlow, PaymentMethod, PaymentMethodsWithDeferredStatus, PaymentProvider, PaymentStatusPoll, PaymentType, PostFinancePaymentMethods, PseudoRecurringPaymentMethods, RNW_ANALYTICS_FIELDS, RNW_COVER_FEE_FIELDS, RNW_INTEGRATION_FIELDS, RNW_PRODUCT_FIELDS, RecurringInterval, RecurringPaymentMethods, SUPPORTER_FIELDS, SUPPORTER_METADATA_FIELDS, SubscriptionStatus, TransactionStatus, WatchedEpikQueryParams, createCronHelper, createEpik, createEpikConfig, createEpikEvents, createEpmsApiProxy, createEppApiProxy, createPayment, createPaymentStatusPoll, getCreditCardType, getLocationParams, getSupportedPaymentTypes, isCreditCardPaymentMethod, isPaymentMethodWithDeferredStatus, isPaymentTypeSupported, isPostFinancePaymentMethod, isSupportedPaymentMethod, isSupportedPaymentProvider, normalizeValues, prepareReturnUrl };
